import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as F } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const i = F((c, h) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: h,
    ...c,
    image: (l) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 3375,
        height: 2125,
        fill: "none",
        viewBox: "0 0 3375 2125",
        ...l,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2_430",
              width: 574,
              height: 561,
              x: 1496,
              y: 783,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "luminance"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "#fff",
                  d: "M1783.48 783.053c-158.48 0-287.05 123.796-287.05 276.587 0 162.44 122.98 283.87 287.05 283.87 159.96 0 286.26-123.04 286.26-280.68 0-156.71-125.46-279.777-286.26-279.777"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsxs("g", { fillRule: "evenodd", clipRule: "evenodd", mask: "url(#mask0_2_430)", children: [
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEFE0",
                d: "M1783.09 1063.27h-1.11a1.105 1.105 0 1 0 2.21.01 1.105 1.105 0 0 0-2.21-.01"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEFE0",
                d: "M1781.98 1063.27c0-.61.49-1.1 1.11-1.1a1.105 1.105 0 1 1-1.11 1.1h-1.1c0 1.22.99 2.22 2.21 2.22s2.21-1 2.21-2.22c0-1.21-.99-2.2-2.21-2.2s-2.21.99-2.21 2.2"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEFE0",
                d: "M1780.88 1063.27a2.21 2.21 0 0 1 4.42 0c0 1.22-.99 2.22-2.21 2.22s-2.21-1-2.21-2.22h-1.12c0 1.84 1.49 3.33 3.33 3.33a3.325 3.325 0 1 0-3.33-3.33"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEFE0",
                d: "M1779.76 1063.27a3.325 3.325 0 1 1 6.65.01 3.325 3.325 0 0 1-6.65-.01h-1.1c0 2.44 1.98 4.43 4.43 4.43 2.44 0 4.43-1.99 4.43-4.43 0-2.43-1.99-4.43-4.43-4.43-2.45 0-4.43 2-4.43 4.43"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEFE0",
                d: "M1778.66 1063.27c0-2.43 1.98-4.43 4.43-4.43 2.44 0 4.43 2 4.43 4.43 0 2.44-1.99 4.43-4.43 4.43-2.45 0-4.43-1.99-4.43-4.43h-1.1c0 3.06 2.47 5.54 5.53 5.54a5.535 5.535 0 0 0 0-11.07c-3.06 0-5.53 2.48-5.53 5.53"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEFDF",
                d: "M1777.56 1063.27a5.529 5.529 0 1 1 11.06 0c0 3.06-2.48 5.54-5.53 5.54-3.06 0-5.53-2.48-5.53-5.54h-1.11c0 3.67 2.97 6.65 6.64 6.65s6.64-2.98 6.64-6.65c0-3.66-2.97-6.63-6.64-6.63s-6.64 2.97-6.64 6.63"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEFDF",
                d: "M1776.45 1063.27c0-3.66 2.97-6.63 6.64-6.63s6.64 2.97 6.64 6.63c0 3.67-2.97 6.65-6.64 6.65s-6.64-2.98-6.64-6.65h-1.12a7.76 7.76 0 0 0 7.76 7.76c4.27 0 7.75-3.47 7.75-7.76 0-4.28-3.48-7.75-7.75-7.75-4.28 0-7.76 3.47-7.76 7.75"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEEDF",
                d: "M1775.34 1063.27a7.75 7.75 0 0 1 7.75-7.75c4.27 0 7.75 3.47 7.75 7.75 0 4.29-3.48 7.76-7.75 7.76-4.28 0-7.75-3.47-7.75-7.76h-1.11c0 4.89 3.97 8.86 8.86 8.86s8.86-3.97 8.86-8.86c0-4.88-3.97-8.85-8.86-8.85s-8.86 3.97-8.86 8.85"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEEDE",
                d: "M1774.23 1063.27c0-4.88 3.97-8.85 8.86-8.85s8.86 3.97 8.86 8.85c0 4.89-3.97 8.86-8.86 8.86s-8.86-3.97-8.86-8.86h-1.1c0 5.51 4.46 9.97 9.96 9.97s9.96-4.46 9.96-9.97c0-5.5-4.46-9.96-9.96-9.96s-9.96 4.46-9.96 9.96"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEEDE",
                d: "M1773.13 1063.27c0-5.5 4.46-9.96 9.96-9.96s9.96 4.46 9.96 9.96c0 5.51-4.46 9.97-9.96 9.97s-9.96-4.46-9.96-9.97h-1.11c0 6.12 4.95 11.08 11.07 11.08s11.07-4.96 11.07-11.08c0-6.11-4.95-11.06-11.07-11.06s-11.07 4.95-11.07 11.06"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEEDE",
                d: "M1772.02 1063.27c0-6.11 4.95-11.06 11.07-11.06s11.07 4.95 11.07 11.06c0 6.12-4.95 11.08-11.07 11.08s-11.07-4.96-11.07-11.08h-1.11c0 6.73 5.46 12.19 12.18 12.19s12.18-5.46 12.18-12.19c0-6.72-5.46-12.18-12.18-12.18s-12.18 5.46-12.18 12.18"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEEDD",
                d: "M1770.91 1063.27c0-6.72 5.46-12.18 12.18-12.18s12.18 5.46 12.18 12.18c0 6.73-5.46 12.19-12.18 12.19s-12.18-5.46-12.18-12.19h-1.11c0 7.34 5.95 13.29 13.29 13.29s13.29-5.95 13.29-13.29c0-7.33-5.95-13.28-13.29-13.28s-13.29 5.95-13.29 13.28"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEDDC",
                d: "M1769.8 1063.27c0-7.33 5.95-13.28 13.29-13.28s13.29 5.95 13.29 13.28c0 7.34-5.95 13.29-13.29 13.29s-13.29-5.95-13.29-13.29h-1.1c0 7.96 6.44 14.4 14.39 14.4 7.94 0 14.39-6.44 14.39-14.4 0-7.94-6.45-14.39-14.39-14.39-7.95 0-14.39 6.45-14.39 14.39"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEDDC",
                d: "M1768.7 1063.27c0-7.94 6.44-14.39 14.39-14.39 7.94 0 14.39 6.45 14.39 14.39 0 7.96-6.45 14.4-14.39 14.4-7.95 0-14.39-6.44-14.39-14.4h-1.11c0 8.57 6.93 15.51 15.5 15.51 8.56 0 15.5-6.94 15.5-15.51 0-8.55-6.94-15.49-15.5-15.49-8.57 0-15.5 6.94-15.5 15.49"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEDDB",
                d: "M1767.59 1063.27c0-8.55 6.93-15.49 15.5-15.49 8.56 0 15.5 6.94 15.5 15.49 0 8.57-6.94 15.51-15.5 15.51-8.57 0-15.5-6.94-15.5-15.51h-1.11c0 9.17 7.44 16.62 16.61 16.62s16.61-7.45 16.61-16.62-7.44-16.6-16.61-16.6-16.61 7.43-16.61 16.6"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEDDB",
                d: "M1766.48 1063.27c0-9.17 7.44-16.6 16.61-16.6s16.61 7.43 16.61 16.6-7.44 16.62-16.61 16.62-16.61-7.45-16.61-16.62h-1.11c0 9.79 7.93 17.72 17.72 17.72 9.77 0 17.72-7.93 17.72-17.72 0-9.78-7.95-17.71-17.72-17.71-9.79 0-17.72 7.93-17.72 17.71"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEECDA",
                d: "M1765.37 1063.27c0-9.78 7.93-17.71 17.72-17.71 9.77 0 17.72 7.93 17.72 17.71 0 9.79-7.95 17.72-17.72 17.72-9.79 0-17.72-7.93-17.72-17.72h-1.1c0 10.39 8.43 18.82 18.82 18.82s18.82-8.43 18.82-18.82-8.43-18.82-18.82-18.82-18.82 8.43-18.82 18.82"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEECDA",
                d: "M1764.27 1063.27c0-10.39 8.43-18.82 18.82-18.82s18.82 8.43 18.82 18.82-8.43 18.82-18.82 18.82-18.82-8.43-18.82-18.82h-1.11c0 11.01 8.92 19.94 19.93 19.94s19.93-8.93 19.93-19.94c0-11-8.92-19.92-19.93-19.92s-19.93 8.92-19.93 19.92"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEECD9",
                d: "M1763.16 1063.27c0-11 8.92-19.92 19.93-19.92 11 0 19.93 8.92 19.93 19.92 0 11.01-8.93 19.94-19.93 19.94-11.01 0-19.93-8.93-19.93-19.94h-1.11c0 11.62 9.42 21.04 21.04 21.04s21.04-9.42 21.04-21.04-9.42-21.03-21.04-21.03-21.04 9.41-21.04 21.03"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEECD9",
                d: "M1762.05 1063.27c0-11.62 9.42-21.03 21.04-21.03s21.04 9.41 21.04 21.03-9.42 21.05-21.04 21.05-21.04-9.43-21.04-21.05h-1.11c0 12.23 9.91 22.15 22.15 22.15 12.22 0 22.15-9.92 22.15-22.15 0-12.22-9.93-22.14-22.15-22.14-12.24 0-22.15 9.92-22.15 22.14"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEBD8",
                d: "M1760.94 1063.27c0-12.22 9.91-22.14 22.15-22.14 12.22 0 22.15 9.92 22.15 22.14 0 12.23-9.93 22.15-22.15 22.15-12.24 0-22.15-9.92-22.15-22.15h-1.1c0 12.84 10.41 23.25 23.25 23.25s23.25-10.41 23.25-23.25-10.41-23.25-23.25-23.25-23.25 10.41-23.25 23.25"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEBD8",
                d: "M1759.84 1063.27c0-12.84 10.41-23.25 23.25-23.25s23.25 10.41 23.25 23.25-10.41 23.25-23.25 23.25-23.25-10.41-23.25-23.25h-1.11c0 13.46 10.9 24.37 24.36 24.37 13.44 0 24.35-10.91 24.35-24.37 0-13.45-10.91-24.35-24.35-24.35-13.46 0-24.36 10.9-24.36 24.35"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEBD7",
                d: "M1758.73 1063.27c0-13.45 10.9-24.35 24.36-24.35 13.44 0 24.35 10.9 24.35 24.35 0 13.46-10.91 24.37-24.35 24.37-13.46 0-24.36-10.91-24.36-24.37h-1.11c0 14.06 11.41 25.47 25.47 25.47s25.47-11.41 25.47-25.47c0-14.05-11.41-25.46-25.47-25.46s-25.47 11.41-25.47 25.46"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEAD7",
                d: "M1757.62 1063.27c0-14.05 11.41-25.46 25.47-25.46s25.47 11.41 25.47 25.46c0 14.06-11.41 25.47-25.47 25.47s-25.47-11.41-25.47-25.47h-1.11c0 14.68 11.91 26.58 26.58 26.58s26.57-11.9 26.57-26.58c0-14.67-11.9-26.57-26.57-26.57s-26.58 11.9-26.58 26.57"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEAD6",
                d: "M1756.51 1063.27c0-14.67 11.91-26.57 26.58-26.57s26.57 11.9 26.57 26.57c0 14.68-11.9 26.58-26.57 26.58s-26.58-11.9-26.58-26.58h-1.1c0 15.29 12.39 27.68 27.68 27.68s27.68-12.39 27.68-27.68c0-15.28-12.39-27.68-27.68-27.68s-27.68 12.4-27.68 27.68"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FEEAD6",
                d: "M1755.41 1063.27c0-15.28 12.39-27.68 27.68-27.68s27.68 12.4 27.68 27.68c0 15.29-12.39 27.68-27.68 27.68s-27.68-12.39-27.68-27.68h-1.11c0 15.9 12.89 28.8 28.79 28.8 15.89 0 28.78-12.9 28.78-28.8 0-15.89-12.89-28.78-28.78-28.78-15.9 0-28.79 12.89-28.79 28.78"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE9D4",
                d: "M1754.3 1063.27c0-15.89 12.89-28.78 28.79-28.78 15.89 0 28.78 12.89 28.78 28.78 0 15.9-12.89 28.8-28.78 28.8-15.9 0-28.79-12.9-28.79-28.8h-1.11c0 16.51 13.39 29.9 29.9 29.9s29.9-13.39 29.9-29.9c0-16.5-13.39-29.88-29.9-29.88s-29.9 13.38-29.9 29.88"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE9D4",
                d: "M1753.19 1063.27c0-16.5 13.39-29.88 29.9-29.88s29.9 13.38 29.9 29.88c0 16.51-13.39 29.9-29.9 29.9s-29.9-13.39-29.9-29.9h-1.11c0 17.13 13.89 31.01 31.01 31.01s31-13.88 31-31.01c0-17.12-13.88-31-31-31s-31.01 13.88-31.01 31"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE9D3",
                d: "M1752.08 1063.27c0-17.12 13.89-31 31.01-31s31 13.88 31 31c0 17.13-13.88 31.01-31 31.01s-31.01-13.88-31.01-31.01h-1.1c0 17.74 14.37 32.11 32.11 32.11 17.73 0 32.11-14.37 32.11-32.11 0-17.73-14.38-32.1-32.11-32.1-17.74 0-32.11 14.37-32.11 32.1"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE8D3",
                d: "M1750.98 1063.27c0-17.73 14.37-32.1 32.11-32.1 17.73 0 32.11 14.37 32.11 32.1 0 17.74-14.38 32.11-32.11 32.11-17.74 0-32.11-14.37-32.11-32.11h-1.1c0 18.35 14.87 33.23 33.21 33.23s33.21-14.88 33.21-33.23c0-18.34-14.87-33.21-33.21-33.21s-33.21 14.87-33.21 33.21"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE8D2",
                d: "M1749.87 1063.27c0-18.34 14.88-33.21 33.22-33.21s33.21 14.87 33.21 33.21c0 18.35-14.87 33.23-33.21 33.23s-33.22-14.88-33.22-33.23h-1.11c0 18.96 15.37 34.33 34.33 34.33s34.33-15.37 34.33-34.33c0-18.95-15.37-34.31-34.33-34.31s-34.33 15.36-34.33 34.31"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE8D2",
                d: "M1748.76 1063.27c0-18.95 15.37-34.31 34.33-34.31s34.33 15.36 34.33 34.31c0 18.96-15.37 34.33-34.33 34.33s-34.33-15.37-34.33-34.33h-1.1c0 19.56 15.86 35.44 35.43 35.44 19.56 0 35.43-15.88 35.43-35.44s-15.87-35.43-35.43-35.43c-19.57 0-35.43 15.87-35.43 35.43"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE7D1",
                d: "M1747.66 1063.27c0-19.56 15.86-35.43 35.43-35.43 19.56 0 35.43 15.87 35.43 35.43s-15.87 35.44-35.43 35.44c-19.57 0-35.43-15.88-35.43-35.44h-1.11c0 20.18 16.35 36.54 36.54 36.54 20.18 0 36.54-16.36 36.54-36.54 0-20.17-16.36-36.53-36.54-36.53-20.19 0-36.54 16.36-36.54 36.53"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE7D0",
                d: "M1746.55 1063.27c0-20.17 16.35-36.53 36.54-36.53 20.18 0 36.54 16.36 36.54 36.53 0 20.18-16.36 36.54-36.54 36.54-20.19 0-36.54-16.36-36.54-36.54h-1.1c0 20.79 16.85 37.66 37.64 37.66s37.64-16.87 37.64-37.66-16.85-37.64-37.64-37.64-37.64 16.85-37.64 37.64"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE7D0",
                d: "M1745.45 1063.27c0-20.79 16.85-37.64 37.64-37.64s37.64 16.85 37.64 37.64-16.85 37.66-37.64 37.66-37.64-16.87-37.64-37.66h-1.12c0 21.41 17.35 38.76 38.76 38.76 21.4 0 38.76-17.35 38.76-38.76 0-21.39-17.36-38.74-38.76-38.74-21.41 0-38.76 17.35-38.76 38.74"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE6CE",
                d: "M1744.33 1063.27c0-21.39 17.35-38.74 38.76-38.74 21.4 0 38.76 17.35 38.76 38.74 0 21.41-17.36 38.76-38.76 38.76-21.41 0-38.76-17.35-38.76-38.76h-1.1c0 22.01 17.85 39.87 39.86 39.87s39.86-17.86 39.86-39.87-17.85-39.86-39.86-39.86-39.86 17.85-39.86 39.86"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE6CE",
                d: "M1743.23 1063.27c0-22.01 17.85-39.86 39.86-39.86s39.86 17.85 39.86 39.86-17.85 39.87-39.86 39.87-39.86-17.86-39.86-39.87h-1.11c0 22.63 18.34 40.97 40.97 40.97 22.62 0 40.97-18.34 40.97-40.97 0-22.62-18.35-40.96-40.97-40.96-22.63 0-40.97 18.34-40.97 40.96"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE6CD",
                d: "M1742.12 1063.27c0-22.62 18.34-40.96 40.97-40.96s40.97 18.34 40.97 40.96c0 22.63-18.34 40.97-40.97 40.97s-40.97-18.34-40.97-40.97h-1.1c0 23.24 18.83 42.09 42.07 42.09s42.07-18.85 42.07-42.09-18.83-42.07-42.07-42.07-42.07 18.83-42.07 42.07"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE5CD",
                d: "M1741.02 1063.27c0-23.24 18.83-42.07 42.07-42.07s42.07 18.83 42.07 42.07-18.83 42.09-42.07 42.09-42.07-18.85-42.07-42.09h-1.12c0 23.85 19.34 43.19 43.19 43.19 23.84 0 43.19-19.34 43.19-43.19 0-23.84-19.35-43.17-43.19-43.17-23.85 0-43.19 19.33-43.19 43.17"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE4CC",
                d: "M1739.9 1063.27c0-23.84 19.34-43.17 43.19-43.17 23.84 0 43.19 19.33 43.19 43.17 0 23.85-19.35 43.19-43.19 43.19-23.85 0-43.19-19.34-43.19-43.19h-1.1c0 24.46 19.83 44.3 44.29 44.3s44.29-19.84 44.29-44.3c0-24.45-19.83-44.29-44.29-44.29s-44.29 19.84-44.29 44.29"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE4CB",
                d: "M1738.8 1063.27c0-24.45 19.83-44.29 44.29-44.29s44.29 19.84 44.29 44.29c0 24.46-19.83 44.3-44.29 44.3s-44.29-19.84-44.29-44.3h-1.11c0 25.08 20.32 45.4 45.4 45.4 25.06 0 45.4-20.32 45.4-45.4 0-25.06-20.34-45.39-45.4-45.39-25.08 0-45.4 20.33-45.4 45.39"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE3CB",
                d: "M1737.69 1063.27c0-25.06 20.32-45.39 45.4-45.39 25.06 0 45.4 20.33 45.4 45.39 0 25.08-20.34 45.4-45.4 45.4-25.08 0-45.4-20.32-45.4-45.4h-1.1c0 25.68 20.81 46.51 46.5 46.51 25.68 0 46.5-20.83 46.5-46.51 0-25.67-20.82-46.5-46.5-46.5-25.69 0-46.5 20.83-46.5 46.5"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE3CA",
                d: "M1736.59 1063.27c0-25.67 20.81-46.5 46.5-46.5 25.68 0 46.5 20.83 46.5 46.5 0 25.68-20.82 46.51-46.5 46.51-25.69 0-46.5-20.83-46.5-46.51h-1.12c0 26.3 21.33 47.62 47.62 47.62s47.62-21.32 47.62-47.62c0-26.29-21.33-47.6-47.62-47.6s-47.62 21.31-47.62 47.6"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE2C9",
                d: "M1735.47 1063.27c0-26.29 21.32-47.6 47.62-47.6 26.29 0 47.62 21.31 47.62 47.6 0 26.3-21.33 47.62-47.62 47.62-26.3 0-47.62-21.32-47.62-47.62h-1.1c0 26.91 21.81 48.72 48.72 48.72 26.9 0 48.72-21.81 48.72-48.72 0-26.9-21.82-48.72-48.72-48.72-26.91 0-48.72 21.82-48.72 48.72"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE2C9",
                d: "M1734.37 1063.27c0-26.9 21.81-48.72 48.72-48.72 26.9 0 48.72 21.82 48.72 48.72 0 26.91-21.82 48.72-48.72 48.72-26.91 0-48.72-21.81-48.72-48.72h-1.11c0 27.52 22.32 49.83 49.83 49.83s49.83-22.31 49.83-49.83c0-27.51-22.32-49.82-49.83-49.82s-49.83 22.31-49.83 49.82"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE2C8",
                d: "M1733.26 1063.27c0-27.51 22.32-49.82 49.83-49.82s49.83 22.31 49.83 49.82c0 27.52-22.32 49.83-49.83 49.83s-49.83-22.31-49.83-49.83h-1.1c0 28.13 22.8 50.94 50.93 50.94s50.93-22.81 50.93-50.94c0-28.12-22.8-50.93-50.93-50.93s-50.93 22.81-50.93 50.93"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE1C6",
                d: "M1732.16 1063.27c0-28.12 22.8-50.93 50.93-50.93s50.93 22.81 50.93 50.93c0 28.13-22.8 50.94-50.93 50.94s-50.93-22.81-50.93-50.94h-1.12c0 28.75 23.31 52.05 52.05 52.05s52.05-23.3 52.05-52.05c0-28.74-23.31-52.03-52.05-52.03s-52.05 23.29-52.05 52.03"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE1C6",
                d: "M1731.04 1063.27c0-28.74 23.31-52.03 52.05-52.03s52.05 23.29 52.05 52.03c0 28.75-23.31 52.05-52.05 52.05s-52.05-23.3-52.05-52.05h-1.1c0 29.35 23.79 53.15 53.15 53.15 29.35 0 53.15-23.8 53.15-53.15 0-29.34-23.8-53.15-53.15-53.15-29.36 0-53.15 23.81-53.15 53.15"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE0C5",
                d: "M1729.94 1063.27c0-29.34 23.79-53.15 53.15-53.15 29.35 0 53.15 23.81 53.15 53.15 0 29.35-23.8 53.15-53.15 53.15-29.36 0-53.15-23.8-53.15-53.15h-1.11c0 29.97 24.3 54.26 54.26 54.26s54.25-24.29 54.25-54.26c0-29.96-24.29-54.25-54.25-54.25s-54.26 24.29-54.26 54.25"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE0C4",
                d: "M1728.83 1063.27c0-29.96 24.3-54.25 54.26-54.25s54.26 24.29 54.26 54.25c0 29.97-24.3 54.26-54.26 54.26s-54.26-24.29-54.26-54.26h-1.1c0 30.58 24.78 55.37 55.36 55.37 30.57 0 55.36-24.79 55.36-55.37 0-30.57-24.79-55.35-55.36-55.35-30.58 0-55.36 24.78-55.36 55.35"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDE0C4",
                d: "M1727.73 1063.27c0-30.57 24.78-55.35 55.36-55.35 30.57 0 55.36 24.78 55.36 55.35 0 30.58-24.79 55.37-55.36 55.37-30.58 0-55.36-24.79-55.36-55.37h-1.12c0 31.18 25.3 56.48 56.48 56.48s56.48-25.3 56.48-56.48-25.3-56.46-56.48-56.46-56.48 25.28-56.48 56.46"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDDFC3",
                d: "M1726.61 1063.27c0-31.18 25.3-56.46 56.48-56.46s56.48 25.28 56.48 56.46c0 31.19-25.3 56.48-56.48 56.48s-56.48-25.29-56.48-56.48h-1.1c0 31.8 25.78 57.58 57.58 57.58s57.58-25.78 57.58-57.58c0-31.79-25.78-57.57-57.58-57.57s-57.58 25.78-57.58 57.57"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDDFC2",
                d: "M1725.51 1063.27c0-31.79 25.78-57.57 57.58-57.57s57.58 25.78 57.58 57.57c0 31.8-25.78 57.58-57.58 57.58s-57.58-25.78-57.58-57.58h-1.11c0 32.41 26.28 58.69 58.69 58.69s58.68-26.28 58.68-58.69-26.27-58.68-58.68-58.68-58.69 26.27-58.69 58.68"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDDEC2",
                d: "M1724.41 1063.27c0-32.41 26.27-58.68 58.68-58.68s58.69 26.27 58.69 58.68-26.28 58.69-58.69 58.69-58.68-26.28-58.68-58.69h-1.11c0 33.02 26.76 59.8 59.79 59.8 33.02 0 59.79-26.78 59.79-59.8 0-33.01-26.77-59.78-59.79-59.78-33.03 0-59.79 26.77-59.79 59.78"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDDEC1",
                d: "M1723.3 1063.27c0-33.01 26.76-59.78 59.79-59.78 33.02 0 59.79 26.77 59.79 59.78 0 33.02-26.77 59.8-59.79 59.8-33.03 0-59.79-26.78-59.79-59.8h-1.12c0 33.63 27.28 60.91 60.91 60.91s60.9-27.28 60.9-60.91-27.27-60.89-60.9-60.89-60.91 27.26-60.91 60.89"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDDEC0",
                d: "M1722.18 1063.27c0-33.63 27.28-60.89 60.91-60.89s60.9 27.26 60.9 60.89-27.27 60.91-60.9 60.91-60.91-27.28-60.91-60.91h-1.1c0 34.25 27.76 62.01 62.01 62.01s62.01-27.76 62.01-62.01c0-34.24-27.76-62-62.01-62s-62.01 27.76-62.01 62"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDDDC0",
                d: "M1721.08 1063.27c0-34.24 27.76-62 62.01-62s62.01 27.76 62.01 62c0 34.25-27.76 62.01-62.01 62.01s-62.01-27.76-62.01-62.01h-1.1c0 34.86 28.25 63.12 63.11 63.12 34.85 0 63.11-28.26 63.11-63.12 0-34.85-28.26-63.11-63.11-63.11-34.86 0-63.11 28.26-63.11 63.11"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDDDBF",
                d: "M1719.97 1063.27c0-34.85 28.26-63.11 63.12-63.11 34.85 0 63.11 28.26 63.11 63.11 0 34.86-28.26 63.12-63.11 63.12-34.86 0-63.12-28.26-63.12-63.12h-1.1c0 35.47 28.75 64.23 64.22 64.23 35.46 0 64.22-28.76 64.22-64.23 0-35.46-28.76-64.213-64.22-64.213-35.47 0-64.22 28.753-64.22 64.213"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDDCBD",
                d: "M1718.87 1063.27c0-35.46 28.75-64.213 64.22-64.213s64.22 28.753 64.22 64.213c0 35.47-28.75 64.23-64.22 64.23s-64.22-28.76-64.22-64.23h-1.11c0 36.08 29.25 65.34 65.33 65.34s65.33-29.26 65.33-65.34c0-36.07-29.25-65.317-65.33-65.317s-65.33 29.247-65.33 65.317"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FDDCBC",
                d: "M1717.76 1063.27c0-36.07 29.25-65.317 65.33-65.317s65.33 29.247 65.33 65.317c0 36.08-29.25 65.34-65.33 65.34s-65.33-29.26-65.33-65.34h-1.11c0 36.69 29.76 66.44 66.44 66.44s66.44-29.75 66.44-66.44c0-36.68-29.76-66.432-66.44-66.432s-66.44 29.752-66.44 66.432"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCDBBC",
                d: "M1716.65 1063.27c0-36.68 29.75-66.433 66.44-66.433 36.68 0 66.44 29.753 66.44 66.433 0 36.69-29.76 66.44-66.44 66.44-36.69 0-66.44-29.75-66.44-66.44h-1.1c0 37.3 30.24 67.55 67.54 67.55s67.54-30.25 67.54-67.55c0-37.29-30.24-67.537-67.54-67.537s-67.54 30.247-67.54 67.537"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCDBBB",
                d: "M1715.55 1063.27c0-37.29 30.24-67.537 67.54-67.537s67.54 30.247 67.54 67.537c0 37.3-30.24 67.55-67.54 67.55s-67.54-30.25-67.54-67.55h-1.11c0 37.92 30.73 68.66 68.65 68.66 37.91 0 68.65-30.74 68.65-68.66 0-37.91-30.74-68.642-68.65-68.642-37.92 0-68.65 30.732-68.65 68.642"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCDBBA",
                d: "M1714.44 1063.27c0-37.91 30.73-68.642 68.65-68.642 37.91 0 68.65 30.732 68.65 68.642 0 37.92-30.74 68.66-68.65 68.66-37.92 0-68.65-30.74-68.65-68.66h-1.11c0 38.53 31.23 69.77 69.76 69.77 38.52 0 69.76-31.24 69.76-69.77 0-38.51-31.24-69.746-69.76-69.746-38.53 0-69.76 31.236-69.76 69.746"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCDABA",
                d: "M1713.33 1063.27c0-38.51 31.23-69.746 69.76-69.746 38.52 0 69.76 31.236 69.76 69.746 0 38.53-31.24 69.77-69.76 69.77-38.53 0-69.76-31.24-69.76-69.77h-1.11c0 39.14 31.74 70.87 70.87 70.87s70.87-31.73 70.87-70.87c0-39.13-31.74-70.862-70.87-70.862s-70.87 31.732-70.87 70.862"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCDAB9",
                d: "M1712.22 1063.27c0-39.13 31.74-70.862 70.87-70.862s70.87 31.732 70.87 70.862c0 39.14-31.74 70.87-70.87 70.87s-70.87-31.73-70.87-70.87h-1.1c0 39.75 32.22 71.97 71.97 71.97 39.74 0 71.97-32.22 71.97-71.97 0-39.74-32.23-71.966-71.97-71.966-39.75 0-71.97 32.226-71.97 71.966"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD9B8",
                d: "M1711.12 1063.27c0-39.74 32.22-71.966 71.97-71.966 39.74 0 71.97 32.226 71.97 71.966 0 39.75-32.23 71.97-71.97 71.97-39.75 0-71.97-32.22-71.97-71.97h-1.11c0 40.37 32.72 73.09 73.08 73.09 40.35 0 73.08-32.72 73.08-73.09 0-40.36-32.73-73.071-73.08-73.071-40.36 0-73.08 32.711-73.08 73.071"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD9B7",
                d: "M1710.01 1063.27c0-40.36 32.72-73.071 73.08-73.071 40.35 0 73.08 32.711 73.08 73.071 0 40.37-32.73 73.09-73.08 73.09-40.36 0-73.08-32.72-73.08-73.09h-1.11c0 40.97 33.22 74.19 74.19 74.19s74.19-33.22 74.19-74.19c0-40.96-33.22-74.176-74.19-74.176s-74.19 33.216-74.19 74.176"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD8B7",
                d: "M1708.9 1063.27c0-40.96 33.22-74.176 74.19-74.176s74.19 33.216 74.19 74.176c0 40.97-33.22 74.19-74.19 74.19s-74.19-33.22-74.19-74.19h-1.11c0 41.59 33.72 75.3 75.3 75.3s75.3-33.71 75.3-75.3c0-41.58-33.72-75.291-75.3-75.291s-75.3 33.711-75.3 75.291"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD8B6",
                d: "M1707.79 1063.27c0-41.58 33.72-75.291 75.3-75.291s75.3 33.711 75.3 75.291c0 41.59-33.72 75.3-75.3 75.3s-75.3-33.71-75.3-75.3h-1.1c0 42.19 34.2 76.4 76.4 76.4 42.19 0 76.4-34.21 76.4-76.4 0-42.18-34.21-76.396-76.4-76.396-42.2 0-76.4 34.216-76.4 76.396"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD7B4",
                d: "M1706.69 1063.27c0-42.18 34.2-76.395 76.4-76.395 42.19 0 76.4 34.215 76.4 76.395 0 42.19-34.21 76.4-76.4 76.4-42.2 0-76.4-34.21-76.4-76.4h-1.11c0 42.8 34.7 77.52 77.51 77.52 42.8 0 77.51-34.72 77.51-77.52s-34.71-77.5-77.51-77.5c-42.81 0-77.51 34.7-77.51 77.5"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD7B4",
                d: "M1705.58 1063.27c0-42.8 34.7-77.5 77.51-77.5 42.8 0 77.51 34.7 77.51 77.5s-34.71 77.52-77.51 77.52c-42.81 0-77.51-34.72-77.51-77.52h-1.11c0 43.42 35.2 78.62 78.62 78.62s78.62-35.2 78.62-78.62c0-43.41-35.2-78.605-78.62-78.605s-78.62 35.195-78.62 78.605"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD7B4",
                d: "M1704.47 1063.27c0-43.41 35.2-78.605 78.62-78.605s78.62 35.195 78.62 78.605c0 43.42-35.2 78.62-78.62 78.62s-78.62-35.2-78.62-78.62h-1.11c0 44.03 35.7 79.73 79.73 79.73 44.02 0 79.73-35.7 79.73-79.73s-35.71-79.72-79.73-79.72c-44.03 0-79.73 35.69-79.73 79.72"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD6B2",
                d: "M1703.36 1063.27c0-44.03 35.7-79.72 79.73-79.72 44.02 0 79.73 35.69 79.73 79.72s-35.71 79.73-79.73 79.73c-44.03 0-79.73-35.7-79.73-79.73h-1.1c0 44.64 36.19 80.83 80.83 80.83s80.83-36.19 80.83-80.83c0-44.63-36.19-80.825-80.83-80.825s-80.83 36.195-80.83 80.825"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD6B1",
                d: "M1702.26 1063.27c0-44.63 36.19-80.824 80.83-80.824s80.83 36.194 80.83 80.824c0 44.64-36.19 80.83-80.83 80.83s-80.83-36.19-80.83-80.83h-1.11c0 45.25 36.69 81.94 81.94 81.94s81.94-36.69 81.94-81.94-36.69-81.929-81.94-81.929-81.94 36.679-81.94 81.929"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD5B0",
                d: "M1701.15 1063.27c0-45.25 36.69-81.929 81.94-81.929s81.94 36.679 81.94 81.929-36.69 81.94-81.94 81.94-81.94-36.69-81.94-81.94h-1.11c0 45.87 37.18 83.04 83.05 83.04s83.05-37.17 83.05-83.04c0-45.86-37.18-83.034-83.05-83.034s-83.05 37.174-83.05 83.034"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD5AF",
                d: "M1700.04 1063.27c0-45.86 37.18-83.034 83.05-83.034s83.05 37.174 83.05 83.034c0 45.87-37.18 83.04-83.05 83.04s-83.05-37.17-83.05-83.04h-1.11c0 46.47 37.68 84.16 84.16 84.16 46.47 0 84.16-37.69 84.16-84.16s-37.69-84.149-84.16-84.149c-46.48 0-84.16 37.679-84.16 84.149"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD4AF",
                d: "M1698.93 1063.27c0-46.47 37.68-84.149 84.16-84.149 46.47 0 84.16 37.679 84.16 84.149s-37.69 84.16-84.16 84.16c-46.48 0-84.16-37.69-84.16-84.16h-1.1c0 47.09 38.17 85.26 85.26 85.26s85.26-38.17 85.26-85.26c0-47.08-38.17-85.254-85.26-85.254s-85.26 38.174-85.26 85.254"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD4AE",
                d: "M1697.83 1063.27c0-47.08 38.17-85.254 85.26-85.254 47.08 0 85.26 38.174 85.26 85.254 0 47.09-38.18 85.26-85.26 85.26-47.09 0-85.26-38.17-85.26-85.26h-1.11c0 47.7 38.67 86.37 86.37 86.37 47.69 0 86.36-38.67 86.36-86.37 0-47.69-38.67-86.358-86.36-86.358-47.7 0-86.37 38.668-86.37 86.358"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD3AD",
                d: "M1696.72 1063.27c0-47.7 38.67-86.359 86.37-86.359 47.69 0 86.36 38.659 86.36 86.359s-38.67 86.37-86.36 86.37c-47.7 0-86.37-38.67-86.37-86.37h-1.11c0 48.31 39.17 87.47 87.48 87.47 48.3 0 87.48-39.16 87.48-87.47 0-48.3-39.18-87.463-87.48-87.463-48.31 0-87.48 39.163-87.48 87.463"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD3AC",
                d: "M1695.61 1063.27c0-48.3 39.17-87.463 87.48-87.463 48.3 0 87.48 39.163 87.48 87.463 0 48.31-39.18 87.47-87.48 87.47-48.31 0-87.48-39.16-87.48-87.47h-1.11c0 48.92 39.67 88.59 88.59 88.59s88.59-39.67 88.59-88.59c0-48.91-39.67-88.578-88.59-88.578s-88.59 39.668-88.59 88.578"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD2AB",
                d: "M1694.5 1063.27c0-48.91 39.67-88.578 88.59-88.578s88.58 39.668 88.58 88.578c0 48.92-39.66 88.59-88.58 88.59s-88.59-39.67-88.59-88.59h-1.1c0 49.54 40.15 89.69 89.69 89.69 49.53 0 89.69-40.15 89.69-89.69 0-49.53-40.16-89.683-89.69-89.683-49.54 0-89.69 40.153-89.69 89.683"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD2AB",
                d: "M1693.4 1063.27c0-49.53 40.15-89.683 89.69-89.683 49.53 0 89.69 40.153 89.69 89.683 0 49.54-40.16 89.69-89.69 89.69-49.54 0-89.69-40.15-89.69-89.69h-1.11c0 50.14 40.65 90.8 90.8 90.8 50.14 0 90.79-40.66 90.79-90.8 0-50.13-40.65-90.787-90.79-90.787-50.15 0-90.8 40.657-90.8 90.787"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD1AA",
                d: "M1692.29 1063.27c0-50.13 40.65-90.788 90.8-90.788 50.14 0 90.79 40.658 90.79 90.788 0 50.14-40.65 90.8-90.79 90.8-50.15 0-90.8-40.66-90.8-90.8h-1.11c0 50.76 41.15 91.9 91.91 91.9 50.75 0 91.9-41.14 91.9-91.9 0-50.75-41.15-91.892-91.9-91.892-50.76 0-91.91 41.142-91.91 91.892"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD1A9",
                d: "M1691.18 1063.27c0-50.75 41.15-91.892 91.91-91.892 50.75 0 91.9 41.142 91.9 91.892 0 50.76-41.15 91.9-91.9 91.9-50.76 0-91.91-41.14-91.91-91.9h-1.11c0 51.37 41.65 93.02 93.02 93.02s93-41.65 93-93.02c0-51.36-41.63-93.007-93-93.007s-93.02 41.647-93.02 93.007"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD0A8",
                d: "M1690.07 1063.27c0-51.36 41.65-93.007 93.02-93.007s93 41.647 93 93.007c0 51.37-41.63 93.02-93 93.02s-93.02-41.65-93.02-93.02h-1.1c0 51.99 42.14 94.12 94.12 94.12 51.97 0 94.12-42.13 94.12-94.12 0-51.97-42.15-94.112-94.12-94.112-51.98 0-94.12 42.142-94.12 94.112"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCD0A7",
                d: "M1688.97 1063.27c0-51.97 42.14-94.112 94.12-94.112 51.97 0 94.12 42.142 94.12 94.112 0 51.99-42.15 94.12-94.12 94.12-51.98 0-94.12-42.13-94.12-94.12h-1.1c0 52.59 42.63 95.22 95.22 95.22s95.22-42.63 95.22-95.22c0-52.58-42.63-95.217-95.22-95.217s-95.22 42.637-95.22 95.217"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCCFA6",
                d: "M1687.86 1063.27c0-52.58 42.64-95.217 95.23-95.217s95.22 42.637 95.22 95.217c0 52.59-42.63 95.22-95.22 95.22s-95.23-42.63-95.23-95.22h-1.1c0 53.21 43.13 96.33 96.33 96.33s96.33-43.12 96.33-96.33c0-53.2-43.13-96.321-96.33-96.321s-96.33 43.121-96.33 96.321"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCCFA5",
                d: "M1686.76 1063.27c0-53.2 43.13-96.321 96.33-96.321s96.33 43.121 96.33 96.321c0 53.21-43.13 96.33-96.33 96.33s-96.33-43.12-96.33-96.33h-1.1c0 53.81 43.62 97.44 97.43 97.44s97.43-43.63 97.43-97.44c0-53.8-43.62-97.436-97.43-97.436s-97.43 43.636-97.43 97.436"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCCEA4",
                d: "M1685.66 1063.27c0-53.8 43.62-97.436 97.43-97.436s97.43 43.636 97.43 97.436c0 53.81-43.62 97.44-97.43 97.44s-97.43-43.63-97.43-97.44h-1.12c0 54.42 44.13 98.55 98.55 98.55s98.55-44.13 98.55-98.55-44.13-98.541-98.55-98.541-98.55 44.121-98.55 98.541"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FCCEA3",
                d: "M1684.54 1063.27c0-54.42 44.13-98.541 98.55-98.541s98.55 44.121 98.55 98.541-44.13 98.55-98.55 98.55-98.55-44.13-98.55-98.55h-1.1c0 55.04 44.61 99.65 99.65 99.65s99.65-44.61 99.65-99.65c0-55.03-44.61-99.646-99.65-99.646s-99.65 44.616-99.65 99.646"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBCDA2",
                d: "M1683.44 1063.27c0-55.03 44.61-99.646 99.65-99.646s99.65 44.616 99.65 99.646c0 55.04-44.61 99.65-99.65 99.65s-99.65-44.61-99.65-99.65h-1.11c0 55.64 45.11 100.76 100.76 100.76 55.64 0 100.76-45.12 100.76-100.76s-45.12-100.75-100.76-100.75c-55.65 0-100.76 45.11-100.76 100.75"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBCDA1",
                d: "M1682.33 1063.27c0-55.64 45.11-100.75 100.76-100.75 55.64 0 100.76 45.11 100.76 100.75s-45.12 100.76-100.76 100.76c-55.65 0-100.76-45.12-100.76-100.76h-1.1c0 56.26 45.6 101.87 101.86 101.87s101.86-45.61 101.86-101.87c0-56.25-45.6-101.865-101.86-101.865s-101.86 45.615-101.86 101.865"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBCCA1",
                d: "M1681.23 1063.27c0-56.25 45.6-101.866 101.86-101.866s101.86 45.616 101.86 101.866c0 56.26-45.6 101.87-101.86 101.87s-101.86-45.61-101.86-101.87h-1.12c0 56.87 46.11 102.98 102.98 102.98 56.86 0 102.98-46.11 102.98-102.98s-46.12-102.97-102.98-102.97c-56.87 0-102.98 46.1-102.98 102.97"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBCCA0",
                d: "M1680.11 1063.27c0-56.87 46.11-102.97 102.98-102.97 56.86 0 102.98 46.1 102.98 102.97s-46.12 102.98-102.98 102.98c-56.87 0-102.98-46.11-102.98-102.98h-1.1c0 57.49 46.59 104.08 104.08 104.08 57.48 0 104.08-46.59 104.08-104.08 0-57.48-46.6-104.075-104.08-104.075-57.49 0-104.08 46.595-104.08 104.075"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBCB9F",
                d: "M1679.01 1063.27c0-57.48 46.59-104.075 104.08-104.075 57.48 0 104.08 46.595 104.08 104.075 0 57.49-46.6 104.08-104.08 104.08-57.49 0-104.08-46.59-104.08-104.08h-1.11c0 58.09 47.1 105.19 105.19 105.19s105.19-47.1 105.19-105.19c0-58.08-47.1-105.179-105.19-105.179s-105.19 47.099-105.19 105.179"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBCB9E",
                d: "M1677.9 1063.27c0-58.08 47.1-105.179 105.19-105.179s105.19 47.099 105.19 105.179c0 58.09-47.1 105.19-105.19 105.19s-105.19-47.1-105.19-105.19h-1.1c0 58.71 47.58 106.3 106.29 106.3s106.29-47.59 106.29-106.3c0-58.7-47.58-106.284-106.29-106.284s-106.29 47.584-106.29 106.284"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBCA9D",
                d: "M1676.8 1063.27c0-58.7 47.58-106.284 106.29-106.284s106.29 47.584 106.29 106.284c0 58.71-47.58 106.3-106.29 106.3s-106.29-47.59-106.29-106.3h-1.12c0 59.31 48.09 107.41 107.41 107.41 59.31 0 107.41-48.1 107.41-107.41 0-59.3-48.1-107.389-107.41-107.389-59.32 0-107.41 48.089-107.41 107.389"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBCA9C",
                d: "M1675.68 1063.27c0-59.3 48.09-107.389 107.41-107.389 59.31 0 107.41 48.089 107.41 107.389 0 59.31-48.1 107.41-107.41 107.41-59.32 0-107.41-48.1-107.41-107.41h-1.1c0 59.93 48.57 108.51 108.51 108.51 59.92 0 108.51-48.58 108.51-108.51 0-59.92-48.59-108.504-108.51-108.504-59.94 0-108.51 48.584-108.51 108.504"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC99B",
                d: "M1674.58 1063.27c0-59.92 48.57-108.504 108.51-108.504 59.93 0 108.51 48.584 108.51 108.504 0 59.93-48.58 108.51-108.51 108.51-59.94 0-108.51-48.58-108.51-108.51h-1.11c0 60.54 49.08 109.62 109.62 109.62s109.62-49.08 109.62-109.62c0-60.53-49.08-109.609-109.62-109.609s-109.62 49.079-109.62 109.609"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC99B",
                d: "M1673.47 1063.27c0-60.53 49.08-109.608 109.62-109.608s109.62 49.078 109.62 109.608c0 60.54-49.08 109.62-109.62 109.62s-109.62-49.08-109.62-109.62h-1.1c0 61.16 49.56 110.73 110.72 110.73 61.14 0 110.72-49.57 110.72-110.73 0-61.15-49.58-110.713-110.72-110.713-61.16 0-110.72 49.563-110.72 110.713"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC89A",
                d: "M1672.37 1063.27c0-61.15 49.56-110.713 110.72-110.713 61.14 0 110.72 49.563 110.72 110.713 0 61.16-49.58 110.73-110.72 110.73-61.16 0-110.72-49.57-110.72-110.73h-1.12c0 61.76 50.08 111.84 111.84 111.84s111.84-50.08 111.84-111.84c0-61.75-50.08-111.818-111.84-111.818s-111.84 50.068-111.84 111.818"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC899",
                d: "M1671.25 1063.27c0-61.75 50.08-111.818 111.84-111.818s111.84 50.068 111.84 111.818c0 61.76-50.08 111.84-111.84 111.84s-111.84-50.08-111.84-111.84h-1.1c0 62.38 50.57 112.94 112.94 112.94s112.94-50.56 112.94-112.94c0-62.37-50.57-112.933-112.94-112.933s-112.94 50.563-112.94 112.933"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC798",
                d: "M1670.15 1063.27c0-62.37 50.56-112.933 112.94-112.933 62.37 0 112.94 50.563 112.94 112.933 0 62.38-50.57 112.94-112.94 112.94-62.38 0-112.94-50.56-112.94-112.94h-1.11c0 62.99 51.06 114.05 114.05 114.05s114.05-51.06 114.05-114.05c0-62.98-51.06-114.038-114.05-114.038s-114.05 51.058-114.05 114.038"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC797",
                d: "M1669.04 1063.27c0-62.98 51.06-114.038 114.05-114.038s114.04 51.058 114.04 114.038c0 62.99-51.05 114.05-114.04 114.05s-114.05-51.06-114.05-114.05h-1.1c0 63.6 51.54 115.16 115.15 115.16 63.59 0 115.15-51.56 115.15-115.16 0-63.588-51.56-115.142-115.15-115.142-63.61 0-115.15 51.554-115.15 115.142"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC796",
                d: "M1667.94 1063.27c0-63.588 51.55-115.142 115.15-115.142 63.59 0 115.15 51.554 115.15 115.142 0 63.6-51.56 115.16-115.15 115.16-63.6 0-115.15-51.56-115.15-115.16h-1.12c0 64.21 52.06 116.27 116.27 116.27s116.26-52.06 116.26-116.27c0-64.202-52.05-116.247-116.26-116.247s-116.27 52.045-116.27 116.247"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC795",
                d: "M1666.82 1063.27c0-64.202 52.06-116.247 116.27-116.247s116.26 52.045 116.26 116.247c0 64.21-52.05 116.27-116.26 116.27s-116.27-52.06-116.27-116.27h-1.1c0 64.83 52.55 117.37 117.37 117.37 64.81 0 117.37-52.54 117.37-117.37 0-64.807-52.56-117.362-117.37-117.362-64.82 0-117.37 52.555-117.37 117.362"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC594",
                d: "M1665.72 1063.27c0-64.807 52.55-117.362 117.37-117.362 64.81 0 117.37 52.555 117.37 117.362 0 64.83-52.56 117.37-117.37 117.37-64.82 0-117.37-52.54-117.37-117.37h-1.11c0 65.43 53.05 118.47 118.48 118.47s118.47-53.04 118.47-118.47c0-65.422-53.04-118.466-118.47-118.466s-118.48 53.044-118.48 118.466"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC593",
                d: "M1664.61 1063.27c0-65.422 53.05-118.467 118.48-118.467s118.47 53.045 118.47 118.467c0 65.43-53.04 118.47-118.47 118.47s-118.48-53.04-118.48-118.47h-1.1c0 66.04 53.54 119.59 119.58 119.59s119.58-53.55 119.58-119.59c0-66.036-53.54-119.571-119.58-119.571s-119.58 53.535-119.58 119.571"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC593",
                d: "M1663.51 1063.27c0-66.037 53.54-119.572 119.58-119.572s119.58 53.535 119.58 119.572c0 66.04-53.54 119.59-119.58 119.59s-119.58-53.55-119.58-119.59h-1.12c0 66.66 54.04 120.69 120.7 120.69s120.69-54.03 120.69-120.69c0-66.652-54.03-120.676-120.69-120.676s-120.7 54.024-120.7 120.676"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC492",
                d: "M1662.39 1063.27c0-66.651 54.04-120.676 120.7-120.676s120.69 54.025 120.69 120.676c0 66.66-54.03 120.69-120.69 120.69s-120.7-54.03-120.7-120.69h-1.1c0 67.26 54.54 121.8 121.8 121.8s121.8-54.54 121.8-121.8c0-67.256-54.54-121.791-121.8-121.791s-121.8 54.535-121.8 121.791"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC491",
                d: "M1661.29 1063.27c0-67.256 54.54-121.791 121.8-121.791s121.8 54.535 121.8 121.791c0 67.26-54.54 121.8-121.8 121.8s-121.8-54.54-121.8-121.8h-1.11c0 67.88 55.03 122.9 122.91 122.9s122.9-55.02 122.9-122.9c0-67.871-55.02-122.896-122.9-122.896s-122.91 55.025-122.91 122.896"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC390",
                d: "M1660.18 1063.27c0-67.871 55.03-122.896 122.91-122.896s122.9 55.025 122.9 122.896c0 67.88-55.02 122.9-122.9 122.9s-122.91-55.02-122.91-122.9h-1.1c0 68.49 55.52 124.02 124.01 124.02s124.01-55.53 124.01-124.02c0-68.485-55.52-124-124.01-124s-124.01 55.515-124.01 124"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC38F",
                d: "M1659.08 1063.27c0-68.486 55.52-124.001 124.01-124.001s124.01 55.515 124.01 124.001c0 68.49-55.52 124.02-124.01 124.02s-124.01-55.53-124.01-124.02h-1.11c0 69.11 56.01 125.12 125.12 125.12 69.1 0 125.12-56.01 125.12-125.12 0-69.09-56.02-125.105-125.12-125.105-69.11 0-125.12 56.015-125.12 125.105"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC28E",
                d: "M1657.96 1063.27c0-69.09 56.02-125.105 125.13-125.105 69.1 0 125.12 56.015 125.12 125.105 0 69.11-56.02 125.12-125.12 125.12-69.11 0-125.13-56.01-125.13-125.12h-1.1c0 69.71 56.52 126.23 126.23 126.23s126.23-56.52 126.23-126.23c0-69.705-56.52-126.22-126.23-126.22s-126.23 56.515-126.23 126.22"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC28D",
                d: "M1656.86 1063.27c0-69.705 56.52-126.22 126.23-126.22s126.23 56.515 126.23 126.22c0 69.71-56.52 126.23-126.23 126.23s-126.23-56.52-126.23-126.23h-1.1c0 70.33 57 127.33 127.33 127.33 70.32 0 127.33-57 127.33-127.33 0-70.32-57.01-127.325-127.33-127.325-70.33 0-127.33 57.005-127.33 127.325"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC18C",
                d: "M1655.76 1063.27c0-70.32 57-127.325 127.33-127.325 70.32 0 127.33 57.005 127.33 127.325 0 70.33-57.01 127.33-127.33 127.33-70.33 0-127.33-57-127.33-127.33h-1.11c0 70.93 57.51 128.45 128.44 128.45s128.44-57.52 128.44-128.45c0-70.924-57.51-128.43-128.44-128.43s-128.44 57.506-128.44 128.43"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FBC18B",
                d: "M1654.65 1063.27c0-70.924 57.51-128.43 128.44-128.43s128.44 57.506 128.44 128.43c0 70.93-57.51 128.45-128.44 128.45s-128.44-57.52-128.44-128.45h-1.11c0 71.55 58 129.55 129.55 129.55 71.54 0 129.55-58 129.55-129.55 0-71.539-58.01-129.534-129.55-129.534-71.55 0-129.55 57.995-129.55 129.534"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAC08A",
                d: "M1653.54 1063.27c0-71.539 58-129.535 129.55-129.535s129.55 57.996 129.55 129.535c0 71.55-58 129.55-129.55 129.55s-129.55-58-129.55-129.55h-1.11c0 72.16 58.5 130.66 130.66 130.66s130.66-58.5 130.66-130.66c0-72.154-58.5-130.65-130.66-130.65s-130.66 58.496-130.66 130.65"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABF89",
                d: "M1652.43 1063.27c0-72.154 58.5-130.65 130.66-130.65s130.66 58.496 130.66 130.65c0 72.16-58.5 130.66-130.66 130.66s-130.66-58.5-130.66-130.66h-1.1c0 72.77 58.98 131.76 131.76 131.76 72.76 0 131.76-58.99 131.76-131.76 0-72.759-59-131.754-131.76-131.754-72.78 0-131.76 58.995-131.76 131.754"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABF89",
                d: "M1651.33 1063.27c0-72.758 58.98-131.754 131.76-131.754 72.76 0 131.76 58.996 131.76 131.754 0 72.77-59 131.76-131.76 131.76-72.78 0-131.76-58.99-131.76-131.76h-1.11c0 73.38 59.49 132.88 132.87 132.88s132.87-59.5 132.87-132.88c0-73.373-59.49-132.859-132.87-132.859s-132.87 59.486-132.87 132.859"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABE88",
                d: "M1650.22 1063.27c0-73.373 59.49-132.859 132.87-132.859s132.87 59.486 132.87 132.859c0 73.38-59.49 132.88-132.87 132.88s-132.87-59.5-132.87-132.88h-1.11c0 74 59.99 133.98 133.98 133.98 73.98 0 133.98-59.98 133.98-133.98 0-73.988-60-133.963-133.98-133.963-73.99 0-133.98 59.975-133.98 133.963"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABE87",
                d: "M1649.11 1063.27c0-73.989 59.98-133.964 133.98-133.964 73.98 0 133.98 59.975 133.98 133.964 0 74-60 133.98-133.98 133.98-74 0-133.98-59.98-133.98-133.98H1648c0 74.61 60.48 135.09 135.09 135.09 74.6 0 135.09-60.48 135.09-135.09 0-74.603-60.49-135.079-135.09-135.079-74.61 0-135.09 60.476-135.09 135.079"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABD86",
                d: "M1648 1063.27c0-74.603 60.48-135.079 135.09-135.079 74.6 0 135.09 60.476 135.09 135.079 0 74.61-60.49 135.09-135.09 135.09-74.61 0-135.09-60.48-135.09-135.09h-1.1c0 75.22 60.97 136.19 136.19 136.19 75.21 0 136.19-60.97 136.19-136.19 0-75.208-60.98-136.183-136.19-136.183-75.22 0-136.19 60.975-136.19 136.183"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABD85",
                d: "M1646.9 1063.27c0-75.207 60.98-136.183 136.19-136.183s136.19 60.976 136.19 136.183c0 75.22-60.98 136.19-136.19 136.19s-136.19-60.97-136.19-136.19h-1.11c0 75.83 61.47 137.31 137.3 137.31s137.3-61.48 137.3-137.31c0-75.822-61.47-137.288-137.3-137.288s-137.3 61.466-137.3 137.288"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABC84",
                d: "M1645.79 1063.27c0-75.823 61.47-137.288 137.3-137.288s137.3 61.465 137.3 137.288c0 75.83-61.47 137.31-137.3 137.31s-137.3-61.48-137.3-137.31h-1.11c0 76.43 61.97 138.41 138.41 138.41 76.43 0 138.41-61.98 138.41-138.41 0-76.427-61.98-138.393-138.41-138.393-76.44 0-138.41 61.966-138.41 138.393"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABC83",
                d: "M1644.68 1063.27c0-76.427 61.97-138.392 138.41-138.392 76.43 0 138.41 61.965 138.41 138.392 0 76.43-61.98 138.41-138.41 138.41-76.44 0-138.41-61.98-138.41-138.41h-1.11c0 77.05 62.46 139.52 139.52 139.52 77.05 0 139.52-62.47 139.52-139.52 0-77.041-62.47-139.507-139.52-139.507-77.06 0-139.52 62.466-139.52 139.507"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABB82",
                d: "M1643.57 1063.27c0-77.041 62.46-139.507 139.52-139.507 77.05 0 139.52 62.466 139.52 139.507 0 77.05-62.47 139.52-139.52 139.52-77.06 0-139.52-62.47-139.52-139.52h-1.1c0 77.66 62.96 140.62 140.62 140.62s140.62-62.96 140.62-140.62c0-77.656-62.96-140.612-140.62-140.612s-140.62 62.956-140.62 140.612"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABA81",
                d: "M1642.47 1063.27c0-77.656 62.96-140.612 140.62-140.612s140.62 62.956 140.62 140.612c0 77.66-62.96 140.62-140.62 140.62s-140.62-62.96-140.62-140.62h-1.11c0 78.28 63.45 141.74 141.73 141.74 78.27 0 141.73-63.46 141.73-141.74 0-78.271-63.46-141.717-141.73-141.717-78.28 0-141.73 63.446-141.73 141.717"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FABA80",
                d: "M1641.36 1063.27c0-78.271 63.45-141.717 141.73-141.717 78.27 0 141.73 63.446 141.73 141.717 0 78.28-63.46 141.74-141.73 141.74-78.28 0-141.73-63.46-141.73-141.74h-1.11c0 78.88 63.96 142.84 142.84 142.84s142.84-63.96 142.84-142.84c0-78.876-63.96-142.822-142.84-142.822s-142.84 63.946-142.84 142.822"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB97F",
                d: "M1640.25 1063.27c0-78.876 63.96-142.821 142.84-142.821s142.84 63.945 142.84 142.821c0 78.88-63.96 142.84-142.84 142.84s-142.84-63.96-142.84-142.84h-1.11c0 79.5 64.45 143.94 143.95 143.94s143.95-64.44 143.95-143.94c0-79.49-64.45-143.936-143.95-143.936s-143.95 64.446-143.95 143.936"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB97E",
                d: "M1639.14 1063.27c0-79.491 64.45-143.937 143.95-143.937s143.95 64.446 143.95 143.937c0 79.5-64.45 143.94-143.95 143.94s-143.95-64.44-143.95-143.94h-1.1c0 80.11 64.94 145.05 145.05 145.05s145.05-64.94 145.05-145.05c0-80.106-64.94-145.041-145.05-145.041s-145.05 64.935-145.05 145.041"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB87D",
                d: "M1638.04 1063.27c0-80.105 64.94-145.041 145.05-145.041s145.05 64.936 145.05 145.041c0 80.11-64.94 145.05-145.05 145.05s-145.05-64.94-145.05-145.05h-1.11c0 80.72 65.44 146.16 146.16 146.16s146.16-65.44 146.16-146.16c0-80.71-65.44-146.146-146.16-146.146s-146.16 65.436-146.16 146.146"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB87D",
                d: "M1636.93 1063.27c0-80.71 65.44-146.146 146.16-146.146s146.15 65.436 146.15 146.146c0 80.72-65.43 146.16-146.15 146.16s-146.16-65.44-146.16-146.16h-1.11c0 81.33 65.94 147.27 147.27 147.27s147.27-65.94 147.27-147.27c0-81.325-65.94-147.25-147.27-147.25s-147.27 65.925-147.27 147.25"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB77C",
                d: "M1635.82 1063.27c0-81.325 65.94-147.251 147.27-147.251s147.27 65.926 147.27 147.251c0 81.33-65.94 147.27-147.27 147.27s-147.27-65.94-147.27-147.27h-1.11c0 81.95 66.43 148.37 148.38 148.37 81.94 0 148.37-66.42 148.37-148.37 0-81.929-66.43-148.366-148.37-148.366-81.95 0-148.38 66.437-148.38 148.366"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB67B",
                d: "M1634.71 1063.27c0-81.929 66.43-148.366 148.38-148.366 81.94 0 148.37 66.437 148.37 148.366 0 81.95-66.43 148.37-148.37 148.37-81.95 0-148.38-66.42-148.38-148.37h-1.1c0 82.55 66.93 149.48 149.48 149.48s149.48-66.93 149.48-149.48c0-82.544-66.93-149.47-149.48-149.47s-149.48 66.926-149.48 149.47"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB67A",
                d: "M1633.61 1063.27c0-82.544 66.93-149.47 149.48-149.47s149.48 66.926 149.48 149.47c0 82.55-66.93 149.48-149.48 149.48s-149.48-66.93-149.48-149.48h-1.11c0 83.17 67.42 150.59 150.59 150.59s150.58-67.42 150.58-150.59c0-83.159-67.41-150.575-150.58-150.575s-150.59 67.416-150.59 150.575"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB579",
                d: "M1632.5 1063.27c0-83.159 67.42-150.575 150.59-150.575s150.58 67.416 150.58 150.575c0 83.17-67.41 150.59-150.58 150.59s-150.59-67.42-150.59-150.59h-1.11c0 83.78 67.92 151.7 151.7 151.7 83.77 0 151.7-67.92 151.7-151.7 0-83.774-67.93-151.68-151.7-151.68-83.78 0-151.7 67.906-151.7 151.68"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB578",
                d: "M1631.39 1063.27c0-83.774 67.92-151.68 151.7-151.68 83.77 0 151.7 67.906 151.7 151.68 0 83.78-67.93 151.7-151.7 151.7-83.78 0-151.7-67.92-151.7-151.7h-1.11c0 84.39 68.42 152.8 152.81 152.8 84.38 0 152.8-68.41 152.8-152.8 0-84.378-68.42-152.795-152.8-152.795-84.39 0-152.81 68.417-152.81 152.795"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB477",
                d: "M1630.29 1063.27c0-84.378 68.41-152.795 152.8-152.795s152.8 68.417 152.8 152.795c0 84.39-68.41 152.8-152.8 152.8s-152.8-68.41-152.8-152.8h-1.11c0 85 68.91 153.91 153.91 153.91S1937 1148.27 1937 1063.27c0-84.993-68.91-153.899-153.91-153.899s-153.91 68.906-153.91 153.899"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB476",
                d: "M1629.18 1063.27c0-84.993 68.91-153.899 153.91-153.899S1937 978.277 1937 1063.27c0 85-68.91 153.91-153.91 153.91s-153.91-68.91-153.91-153.91h-1.1c0 85.62 69.39 155.02 155.01 155.02 85.61 0 155.01-69.4 155.01-155.02 0-85.608-69.4-155.004-155.01-155.004-85.62 0-155.01 69.396-155.01 155.004"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#FAB475",
                d: "M1628.08 1063.27c0-85.608 69.39-155.004 155.01-155.004s155.01 69.396 155.01 155.004c0 85.62-69.39 155.02-155.01 155.02s-155.01-69.4-155.01-155.02h-1.12c0 86.22 69.9 156.13 156.13 156.13 86.22 0 156.13-69.91 156.13-156.13 0-86.213-69.91-156.109-156.13-156.109-86.23 0-156.13 69.896-156.13 156.109"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9B374",
                d: "M1626.96 1063.27c0-86.212 69.9-156.109 156.13-156.109 86.22 0 156.13 69.897 156.13 156.109 0 86.22-69.91 156.13-156.13 156.13-86.23 0-156.13-69.91-156.13-156.13h-1.1c0 86.84 70.4 157.23 157.23 157.23s157.23-70.39 157.23-157.23c0-86.827-70.4-157.224-157.23-157.224s-157.23 70.397-157.23 157.224"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9B373",
                d: "M1625.86 1063.27c0-86.827 70.39-157.224 157.23-157.224 86.83 0 157.23 70.397 157.23 157.224 0 86.84-70.4 157.23-157.23 157.23-86.84 0-157.23-70.39-157.23-157.23h-1.11c0 87.45 70.89 158.34 158.34 158.34 87.44 0 158.34-70.89 158.34-158.34 0-87.442-70.9-158.329-158.34-158.329-87.45 0-158.34 70.887-158.34 158.329"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9B272",
                d: "M1624.75 1063.27c0-87.442 70.89-158.329 158.34-158.329 87.44 0 158.34 70.887 158.34 158.329 0 87.45-70.9 158.34-158.34 158.34-87.45 0-158.34-70.89-158.34-158.34h-1.1c0 88.05 71.39 159.45 159.44 159.45s159.44-71.4 159.44-159.45c0-88.047-71.39-159.433-159.44-159.433s-159.44 71.386-159.44 159.433"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9B171",
                d: "M1623.65 1063.27c0-88.046 71.39-159.433 159.44-159.433s159.44 71.387 159.44 159.433c0 88.06-71.39 159.45-159.44 159.45s-159.44-71.39-159.44-159.45h-1.12c0 88.67 71.89 160.56 160.56 160.56s160.56-71.89 160.56-160.56c0-88.661-71.89-160.537-160.56-160.537s-160.56 71.876-160.56 160.537"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9B171",
                d: "M1622.53 1063.27c0-88.661 71.89-160.538 160.56-160.538s160.56 71.877 160.56 160.538c0 88.67-71.89 160.56-160.56 160.56s-160.56-71.89-160.56-160.56h-1.1c0 89.28 72.38 161.66 161.66 161.66s161.66-72.38 161.66-161.66c0-89.276-72.38-161.653-161.66-161.653s-161.66 72.377-161.66 161.653"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9B070",
                d: "M1621.43 1063.27c0-89.276 72.38-161.653 161.66-161.653s161.66 72.377 161.66 161.653c0 89.28-72.38 161.66-161.66 161.66s-161.66-72.38-161.66-161.66h-1.11c0 89.89 72.87 162.77 162.77 162.77 89.89 0 162.77-72.88 162.77-162.77 0-89.881-72.88-162.758-162.77-162.758-89.9 0-162.77 72.877-162.77 162.758"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9B070",
                d: "M1620.32 1063.27c0-89.88 72.87-162.757 162.77-162.757 89.89 0 162.77 72.877 162.77 162.757 0 89.89-72.88 162.77-162.77 162.77-89.9 0-162.77-72.88-162.77-162.77h-1.1c0 90.5 73.37 163.88 163.87 163.88s163.87-73.38 163.87-163.88c0-90.495-73.37-163.862-163.87-163.862s-163.87 73.367-163.87 163.862"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9AF6E",
                d: "M1619.22 1063.27c0-90.496 73.37-163.862 163.87-163.862s163.87 73.366 163.87 163.862c0 90.5-73.37 163.88-163.87 163.88s-163.87-73.38-163.87-163.88h-1.12c0 91.12 73.87 164.99 164.99 164.99s164.99-73.87 164.99-164.99c0-91.11-73.87-164.967-164.99-164.967S1618.1 972.16 1618.1 1063.27"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9AE6D",
                d: "M1618.1 1063.27c0-91.111 73.87-164.967 164.99-164.967s164.99 73.856 164.99 164.967c0 91.12-73.87 164.99-164.99 164.99s-164.99-73.87-164.99-164.99h-1.1c0 91.73 74.36 166.09 166.09 166.09 91.72 0 166.09-74.36 166.09-166.09 0-91.725-74.37-166.082-166.09-166.082-91.73 0-166.09 74.357-166.09 166.082"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9AE6C",
                d: "M1617 1063.27c0-91.725 74.36-166.082 166.09-166.082 91.72 0 166.09 74.357 166.09 166.082 0 91.73-74.37 166.09-166.09 166.09-91.73 0-166.09-74.36-166.09-166.09h-1.11c0 92.34 74.86 167.2 167.2 167.2s167.2-74.86 167.2-167.2c0-92.33-74.86-167.187-167.2-167.187s-167.2 74.857-167.2 167.187"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9AD6B",
                d: "M1615.89 1063.27c0-92.33 74.86-167.187 167.2-167.187s167.2 74.857 167.2 167.187c0 92.34-74.86 167.19-167.2 167.19s-167.2-74.85-167.2-167.19h-1.1c0 92.95 75.35 168.31 168.3 168.31s168.3-75.36 168.3-168.31c0-92.945-75.35-168.292-168.3-168.292s-168.3 75.347-168.3 168.292"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9AD6A",
                d: "M1614.79 1063.27c0-92.944 75.35-168.291 168.3-168.291s168.3 75.347 168.3 168.291c0 92.95-75.35 168.31-168.3 168.31s-168.3-75.36-168.3-168.31h-1.12c0 93.56 75.85 169.41 169.42 169.41 93.56 0 169.42-75.85 169.42-169.41 0-93.549-75.86-169.396-169.42-169.396-93.57 0-169.42 75.847-169.42 169.396"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9AC69",
                d: "M1613.67 1063.27c0-93.549 75.85-169.396 169.42-169.396 93.56 0 169.42 75.847 169.42 169.396 0 93.56-75.86 169.41-169.42 169.41-93.57 0-169.42-75.85-169.42-169.41h-1.1c0 94.17 76.34 170.52 170.52 170.52 94.17 0 170.52-76.35 170.52-170.52 0-94.164-76.35-170.511-170.52-170.511-94.18 0-170.52 76.347-170.52 170.511"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9AB68",
                d: "M1612.57 1063.27c0-94.164 76.34-170.511 170.52-170.511 94.17 0 170.52 76.347 170.52 170.511 0 94.17-76.35 170.52-170.52 170.52-94.18 0-170.52-76.35-170.52-170.52h-1.11c0 94.79 76.84 171.62 171.63 171.62s171.63-76.83 171.63-171.62c0-94.779-76.84-171.616-171.63-171.616s-171.63 76.837-171.63 171.616"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9AB68",
                d: "M1611.46 1063.27c0-94.779 76.84-171.616 171.63-171.616s171.63 76.837 171.63 171.616c0 94.79-76.84 171.62-171.63 171.62s-171.63-76.83-171.63-171.62h-1.1c0 95.4 77.33 172.73 172.73 172.73 95.39 0 172.73-77.33 172.73-172.73 0-95.383-77.34-172.72-172.73-172.72-95.4 0-172.73 77.337-172.73 172.72"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9AA67",
                d: "M1610.36 1063.27c0-95.384 77.33-172.721 172.73-172.721 95.39 0 172.73 77.337 172.73 172.721 0 95.4-77.34 172.73-172.73 172.73-95.4 0-172.73-77.33-172.73-172.73h-1.12c0 96.01 77.84 173.84 173.85 173.84s173.85-77.83 173.85-173.84c0-95.999-77.84-173.826-173.85-173.826s-173.85 77.827-173.85 173.826"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9AA66",
                d: "M1609.24 1063.27c0-95.998 77.84-173.826 173.85-173.826s173.85 77.828 173.85 173.826c0 96.01-77.84 173.84-173.85 173.84s-173.85-77.83-173.85-173.84h-1.1c0 96.62 78.33 174.95 174.95 174.95s174.95-78.33 174.95-174.95c0-96.613-78.33-174.941-174.95-174.941s-174.95 78.328-174.95 174.941"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9A965",
                d: "M1608.14 1063.27c0-96.613 78.33-174.94 174.95-174.94s174.95 78.327 174.95 174.94c0 96.62-78.33 174.95-174.95 174.95s-174.95-78.33-174.95-174.95h-1.11c0 97.24 78.82 176.05 176.06 176.05 97.23 0 176.05-78.81 176.05-176.05 0-97.228-78.82-176.045-176.05-176.045-97.24 0-176.06 78.817-176.06 176.045"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9A964",
                d: "M1607.03 1063.27c0-97.228 78.82-176.045 176.06-176.045s176.06 78.817 176.06 176.045c0 97.24-78.82 176.05-176.06 176.05s-176.06-78.81-176.06-176.05h-1.1c0 97.84 79.32 177.16 177.16 177.16s177.16-79.32 177.16-177.16c0-97.832-79.32-177.149-177.16-177.149s-177.16 79.317-177.16 177.149"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9A963",
                d: "M1605.93 1063.27c0-97.832 79.32-177.15 177.16-177.15s177.16 79.318 177.16 177.15c0 97.84-79.32 177.16-177.16 177.16s-177.16-79.32-177.16-177.16h-1.12c0 98.46 79.83 178.27 178.28 178.27s178.28-79.81 178.28-178.27c0-98.447-79.83-178.254-178.28-178.254s-178.28 79.807-178.28 178.254"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9A862",
                d: "M1604.81 1063.27c0-98.447 79.82-178.254 178.28-178.254 98.45 0 178.27 79.807 178.27 178.254 0 98.46-79.82 178.27-178.27 178.27-98.46 0-178.28-79.81-178.28-178.27h-1.1c0 99.07 80.31 179.38 179.38 179.38 99.06 0 179.38-80.31 179.38-179.38 0-99.052-80.32-179.37-179.38-179.37-99.07 0-179.38 80.318-179.38 179.37"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9A862",
                d: "M1603.71 1063.27c0-99.051 80.31-179.369 179.38-179.369 99.06 0 179.38 80.318 179.38 179.369 0 99.07-80.32 179.38-179.38 179.38-99.07 0-179.38-80.31-179.38-179.38h-1.11c0 99.67 80.81 180.48 180.49 180.48 99.67 0 180.48-80.81 180.48-180.48 0-99.666-80.81-180.474-180.48-180.474-99.68 0-180.49 80.808-180.49 180.474"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9A761",
                d: "M1602.61 1063.27c0-99.666 80.8-180.474 180.48-180.474 99.67 0 180.49 80.808 180.49 180.474 0 99.67-80.82 180.48-180.49 180.48-99.68 0-180.48-80.81-180.48-180.48h-1.11c0 100.29 81.3 181.59 181.59 181.59s181.59-81.3 181.59-181.59c0-100.281-81.3-181.579-181.59-181.579s-181.59 81.298-181.59 181.579"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9A660",
                d: "M1601.5 1063.27c0-100.281 81.3-181.579 181.59-181.579s181.59 81.298 181.59 181.579c0 100.29-81.3 181.59-181.59 181.59s-181.59-81.3-181.59-181.59h-1.12c0 100.9 81.8 182.7 182.71 182.7 100.89 0 182.7-81.8 182.7-182.7 0-100.896-81.81-182.683-182.7-182.683-100.91 0-182.71 81.787-182.71 182.683"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F9A65F",
                d: "M1600.39 1063.27c0-100.896 81.8-182.683 182.7-182.683 100.89 0 182.7 81.787 182.7 182.683 0 100.9-81.81 182.7-182.7 182.7-100.9 0-182.7-81.8-182.7-182.7h-1.11c0 101.51 82.3 183.81 183.81 183.81s183.81-82.3 183.81-183.81c0-101.501-82.3-183.799-183.81-183.799s-183.81 82.298-183.81 183.799"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A55E",
                d: "M1599.28 1063.27c0-101.5 82.3-183.798 183.81-183.798s183.81 82.298 183.81 183.798c0 101.51-82.3 183.81-183.81 183.81s-183.81-82.3-183.81-183.81h-1.11c0 102.12 82.8 184.91 184.92 184.91S1968 1165.39 1968 1063.27c0-102.115-82.79-184.903-184.91-184.903s-184.92 82.788-184.92 184.903"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A45D",
                d: "M1598.17 1063.27c0-102.115 82.8-184.903 184.92-184.903S1968 961.155 1968 1063.27c0 102.12-82.79 184.91-184.91 184.91s-184.92-82.79-184.92-184.91h-1.1c0 102.74 83.28 186.02 186.02 186.02s186.02-83.28 186.02-186.02c0-102.73-83.28-186.007-186.02-186.007s-186.02 83.277-186.02 186.007"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A45C",
                d: "M1597.07 1063.27c0-102.731 83.28-186.008 186.02-186.008s186.02 83.277 186.02 186.008c0 102.74-83.28 186.02-186.02 186.02s-186.02-83.28-186.02-186.02h-1.1c0 103.34 83.77 187.13 187.12 187.13 103.34 0 187.12-83.79 187.12-187.13 0-103.335-83.78-187.113-187.12-187.113-103.35 0-187.12 83.778-187.12 187.113"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A35C",
                d: "M1595.97 1063.27c0-103.335 83.77-187.112 187.12-187.112 103.34 0 187.12 83.777 187.12 187.112 0 103.34-83.78 187.13-187.12 187.13-103.35 0-187.12-83.79-187.12-187.13h-1.12c0 103.96 84.28 188.24 188.24 188.24s188.24-84.28 188.24-188.24c0-103.949-84.28-188.228-188.24-188.228s-188.24 84.279-188.24 188.228"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A25B",
                d: "M1594.85 1063.27c0-103.949 84.28-188.227 188.24-188.227s188.24 84.278 188.24 188.227c0 103.96-84.28 188.24-188.24 188.24s-188.24-84.28-188.24-188.24h-1.1c0 104.57 84.77 189.34 189.34 189.34 104.56 0 189.34-84.77 189.34-189.34 0-104.564-84.78-189.332-189.34-189.332-104.57 0-189.34 84.768-189.34 189.332"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A25A",
                d: "M1593.75 1063.27c0-104.564 84.77-189.332 189.34-189.332 104.56 0 189.34 84.768 189.34 189.332 0 104.57-84.78 189.34-189.34 189.34-104.57 0-189.34-84.77-189.34-189.34h-1.11c0 105.18 85.27 190.45 190.45 190.45s190.45-85.27 190.45-190.45c0-105.169-85.27-190.437-190.45-190.437s-190.45 85.268-190.45 190.437"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A159",
                d: "M1592.64 1063.27c0-105.169 85.27-190.437 190.45-190.437s190.45 85.268 190.45 190.437c0 105.18-85.27 190.44-190.45 190.44s-190.45-85.26-190.45-190.44h-1.1c0 105.79 85.76 191.56 191.55 191.56s191.55-85.77 191.55-191.56c0-105.784-85.76-191.542-191.55-191.542s-191.55 85.758-191.55 191.542"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A158",
                d: "M1591.54 1063.27c0-105.784 85.76-191.541 191.55-191.541s191.55 85.757 191.55 191.541c0 105.79-85.76 191.56-191.55 191.56s-191.55-85.77-191.55-191.56h-1.12c0 106.41 86.26 192.67 192.67 192.67s192.67-86.26 192.67-192.67c0-106.398-86.26-192.657-192.67-192.657s-192.67 86.259-192.67 192.657"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A157",
                d: "M1590.42 1063.27c0-106.398 86.26-192.656 192.67-192.656s192.67 86.258 192.67 192.656c0 106.41-86.26 192.67-192.67 192.67s-192.67-86.26-192.67-192.67h-1.1c0 107.01 86.75 193.77 193.77 193.77 107.01 0 193.77-86.76 193.77-193.77 0-107.003-86.76-193.761-193.77-193.761-107.02 0-193.77 86.758-193.77 193.761"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A057",
                d: "M1589.32 1063.27c0-107.003 86.75-193.761 193.77-193.761 107.01 0 193.77 86.758 193.77 193.761 0 107.01-86.76 193.77-193.77 193.77-107.02 0-193.77-86.76-193.77-193.77h-1.11c0 107.63 87.25 194.87 194.88 194.87 107.62 0 194.88-87.24 194.88-194.87 0-107.618-87.26-194.866-194.88-194.866-107.63 0-194.88 87.248-194.88 194.866"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8A055",
                d: "M1588.21 1063.27c0-107.618 87.25-194.866 194.88-194.866s194.88 87.248 194.88 194.866c0 107.63-87.25 194.87-194.88 194.87s-194.88-87.24-194.88-194.87h-1.1c0 108.24 87.74 195.99 195.98 195.99s195.98-87.75 195.98-195.99c0-108.233-87.74-195.971-195.98-195.971s-195.98 87.738-195.98 195.971"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F89F54",
                d: "M1587.11 1063.27c0-108.233 87.74-195.971 195.98-195.971s195.98 87.738 195.98 195.971c0 108.24-87.74 195.99-195.98 195.99s-195.98-87.75-195.98-195.99h-1.12c0 108.86 88.24 197.09 197.1 197.09 108.84 0 197.1-88.23 197.1-197.09 0-108.838-88.26-197.086-197.1-197.086-108.86 0-197.1 88.248-197.1 197.086"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F89E53",
                d: "M1585.99 1063.27c0-108.837 88.24-197.086 197.1-197.086 108.84 0 197.1 88.249 197.1 197.086 0 108.86-88.26 197.09-197.1 197.09-108.86 0-197.1-88.23-197.1-197.09h-1.1c0 109.46 88.74 198.2 198.2 198.2s198.2-88.74 198.2-198.2c0-109.452-88.74-198.19-198.2-198.19s-198.2 88.738-198.2 198.19"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F89E53",
                d: "M1584.89 1063.27c0-109.452 88.74-198.19 198.2-198.19s198.2 88.738 198.2 198.19c0 109.46-88.74 198.2-198.2 198.2s-198.2-88.74-198.2-198.2h-1.11c0 110.08 89.23 199.3 199.31 199.3 110.07 0 199.31-89.22 199.31-199.3 0-110.067-89.24-199.295-199.31-199.295-110.08 0-199.31 89.228-199.31 199.295"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F89D52",
                d: "M1583.78 1063.27c0-110.067 89.23-199.296 199.31-199.296s199.31 89.229 199.31 199.296c0 110.07-89.23 199.3-199.31 199.3s-199.31-89.23-199.31-199.3h-1.1c0 110.68 89.73 200.42 200.41 200.42s200.41-89.74 200.41-200.42c0-110.672-89.73-200.4-200.41-200.4s-200.41 89.728-200.41 200.4"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F89C51",
                d: "M1582.68 1063.27c0-110.672 89.73-200.4 200.41-200.4s200.41 89.728 200.41 200.4c0 110.68-89.73 200.42-200.41 200.42s-200.41-89.74-200.41-200.42h-1.12c0 111.29 90.23 201.52 201.53 201.52 111.29 0 201.53-90.23 201.53-201.52 0-111.286-90.24-201.505-201.53-201.505-111.3 0-201.53 90.219-201.53 201.505"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F89C50",
                d: "M1581.56 1063.27c0-111.286 90.23-201.505 201.53-201.505 111.29 0 201.53 90.219 201.53 201.505 0 111.29-90.24 201.52-201.53 201.52-111.3 0-201.53-90.23-201.53-201.52h-1.1c0 111.91 90.72 202.63 202.63 202.63s202.63-90.72 202.63-202.63c0-111.901-90.72-202.62-202.63-202.62s-202.63 90.719-202.63 202.62"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F89B4F",
                d: "M1580.46 1063.27c0-111.901 90.72-202.62 202.63-202.62s202.63 90.719 202.63 202.62c0 111.91-90.72 202.63-202.63 202.63s-202.63-90.72-202.63-202.63h-1.11c0 112.52 91.22 203.73 203.74 203.73 112.51 0 203.74-91.21 203.74-203.73 0-112.506-91.23-203.724-203.74-203.724-112.52 0-203.74 91.218-203.74 203.724"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F89A4F",
                d: "M1579.35 1063.27c0-112.505 91.22-203.724 203.74-203.724 112.51 0 203.74 91.219 203.74 203.724 0 112.52-91.23 203.73-203.74 203.73-112.52 0-203.74-91.21-203.74-203.73h-1.1c0 113.13 91.71 204.85 204.84 204.85s204.84-91.72 204.84-204.85c0-113.12-91.71-204.829-204.84-204.829s-204.84 91.709-204.84 204.829"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F89A4E",
                d: "M1578.25 1063.27c0-113.121 91.71-204.829 204.84-204.829s204.84 91.708 204.84 204.829c0 113.13-91.71 204.85-204.84 204.85s-204.84-91.72-204.84-204.85h-1.12c0 113.74 92.22 205.95 205.96 205.95 113.73 0 205.95-92.21 205.95-205.95 0-113.736-92.22-205.934-205.95-205.934-113.74 0-205.96 92.198-205.96 205.934"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F8994D",
                d: "M1577.13 1063.27c0-113.736 92.22-205.934 205.96-205.934 113.73 0 205.96 92.198 205.96 205.934 0 113.74-92.23 205.95-205.96 205.95-113.74 0-205.96-92.21-205.96-205.95h-1.1c0 114.36 92.7 207.06 207.06 207.06 114.35 0 207.06-92.7 207.06-207.06 0-114.351-92.71-207.049-207.06-207.049-114.36 0-207.06 92.698-207.06 207.049"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F89A4C",
                d: "M1576.03 1063.27c0-114.35 92.7-207.048 207.06-207.048 114.35 0 207.06 92.698 207.06 207.048 0 114.36-92.71 207.06-207.06 207.06-114.36 0-207.06-92.7-207.06-207.06h-1.11c0 114.96 93.21 208.16 208.17 208.16s208.16-93.2 208.16-208.16c0-114.954-93.2-208.153-208.16-208.153s-208.17 93.199-208.17 208.153"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F7994B",
                d: "M1574.92 1063.27c0-114.955 93.21-208.154 208.17-208.154s208.16 93.199 208.16 208.154c0 114.96-93.2 208.16-208.16 208.16s-208.17-93.2-208.17-208.16h-1.1c0 115.58 93.69 209.28 209.27 209.28s209.27-93.7 209.27-209.28c0-115.57-93.69-209.259-209.27-209.259s-209.27 93.689-209.27 209.259"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F7984A",
                d: "M1573.82 1063.27c0-115.57 93.69-209.258 209.27-209.258s209.27 93.688 209.27 209.258c0 115.58-93.69 209.28-209.27 209.28s-209.27-93.7-209.27-209.28h-1.12c0 116.18 94.2 210.38 210.39 210.38 116.18 0 210.38-94.2 210.38-210.38 0-116.174-94.2-210.363-210.38-210.363-116.19 0-210.39 94.189-210.39 210.363"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79849",
                d: "M1572.7 1063.27c0-116.174 94.2-210.363 210.39-210.363 116.18 0 210.38 94.189 210.38 210.363 0 116.18-94.2 210.38-210.38 210.38-116.19 0-210.39-94.2-210.39-210.38h-1.1c0 116.8 94.68 211.49 211.49 211.49 116.8 0 211.49-94.69 211.49-211.49 0-116.789-94.69-211.478-211.49-211.478-116.81 0-211.49 94.689-211.49 211.478"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79748",
                d: "M1571.6 1063.27c0-116.789 94.68-211.478 211.49-211.478 116.8 0 211.49 94.689 211.49 211.478 0 116.8-94.69 211.49-211.49 211.49-116.81 0-211.49-94.69-211.49-211.49h-1.11c0 117.41 95.19 212.59 212.6 212.59s212.59-95.18 212.59-212.59c0-117.404-95.18-212.582-212.59-212.582s-212.6 95.178-212.6 212.582"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79648",
                d: "M1570.49 1063.27c0-117.404 95.19-212.583 212.6-212.583s212.59 95.179 212.59 212.583c0 117.41-95.18 212.59-212.59 212.59s-212.6-95.18-212.6-212.59h-1.1c0 118.03 95.67 213.71 213.7 213.71 118.02 0 213.7-95.68 213.7-213.71 0-118.019-95.68-213.688-213.7-213.688-118.03 0-213.7 95.669-213.7 213.688"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79647",
                d: "M1569.39 1063.27c0-118.019 95.67-213.687 213.7-213.687 118.02 0 213.7 95.668 213.7 213.687 0 118.03-95.68 213.71-213.7 213.71-118.03 0-213.7-95.68-213.7-213.71h-1.12c0 118.63 96.19 214.81 214.82 214.81s214.81-96.18 214.81-214.81c0-118.623-96.18-214.792-214.81-214.792s-214.82 96.169-214.82 214.792"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79546",
                d: "M1568.28 1063.27c0-118.623 96.18-214.792 214.81-214.792s214.81 96.169 214.81 214.792c0 118.63-96.18 214.81-214.81 214.81s-214.81-96.18-214.81-214.81h-1.11c0 119.25 96.67 215.92 215.92 215.92s215.92-96.67 215.92-215.92c0-119.238-96.67-215.907-215.92-215.907s-215.92 96.669-215.92 215.907"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79445",
                d: "M1567.17 1063.27c0-119.238 96.67-215.907 215.92-215.907 119.24 0 215.92 96.669 215.92 215.907 0 119.25-96.68 215.92-215.92 215.92-119.25 0-215.92-96.67-215.92-215.92h-1.11c0 119.86 97.17 217.02 217.03 217.02s217.02-97.16 217.02-217.02c0-119.853-97.16-217.011-217.02-217.011s-217.03 97.158-217.03 217.011"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79445",
                d: "M1566.07 1063.27c0-119.853 97.16-217.012 217.02-217.012s217.02 97.159 217.02 217.012c0 119.86-97.16 217.02-217.02 217.02s-217.02-97.16-217.02-217.02h-1.11c0 120.46 97.65 218.13 218.13 218.13 120.46 0 218.13-97.67 218.13-218.13 0-120.457-97.67-218.117-218.13-218.117-120.48 0-218.13 97.66-218.13 218.117"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79444",
                d: "M1564.96 1063.27c0-120.458 97.65-218.117 218.13-218.117 120.46 0 218.13 97.659 218.13 218.117 0 120.46-97.67 218.13-218.13 218.13-120.48 0-218.13-97.67-218.13-218.13h-1.11c0 121.08 98.16 219.24 219.24 219.24s219.24-98.16 219.24-219.24c0-121.072-98.16-219.221-219.24-219.221s-219.24 98.149-219.24 219.221"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79342",
                d: "M1563.85 1063.27c0-121.072 98.16-219.221 219.24-219.221s219.24 98.149 219.24 219.221c0 121.08-98.16 219.24-219.24 219.24s-219.24-98.16-219.24-219.24h-1.11c0 121.69 98.65 220.34 220.35 220.34 121.68 0 220.35-98.65 220.35-220.34 0-121.687-98.67-220.336-220.35-220.336-121.7 0-220.35 98.649-220.35 220.336"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79342",
                d: "M1562.74 1063.27c0-121.687 98.65-220.336 220.35-220.336 121.68 0 220.35 98.649 220.35 220.336 0 121.7-98.67 220.34-220.35 220.34-121.7 0-220.35-98.64-220.35-220.34h-1.1c0 122.3 99.15 221.45 221.45 221.45s221.45-99.15 221.45-221.45c0-122.291-99.15-221.441-221.45-221.441s-221.45 99.15-221.45 221.441"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79241",
                d: "M1561.64 1063.27c0-122.292 99.15-221.441 221.45-221.441s221.45 99.149 221.45 221.441c0 122.3-99.15 221.45-221.45 221.45s-221.45-99.15-221.45-221.45h-1.11c0 122.91 99.64 222.56 222.56 222.56 122.91 0 222.56-99.65 222.56-222.56 0-122.907-99.65-222.546-222.56-222.546-122.92 0-222.56 99.639-222.56 222.546"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F79140",
                d: "M1560.53 1063.27c0-122.906 99.64-222.546 222.56-222.546 122.91 0 222.56 99.64 222.56 222.546 0 122.91-99.65 222.56-222.56 222.56-122.92 0-222.56-99.65-222.56-222.56h-1.11c0 123.53 100.14 223.67 223.67 223.67s223.67-100.14 223.67-223.67c0-123.521-100.14-223.65-223.67-223.65s-223.67 100.129-223.67 223.65"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F7913F",
                d: "M1559.42 1063.27c0-123.521 100.14-223.65 223.67-223.65s223.67 100.129 223.67 223.65c0 123.53-100.14 223.67-223.67 223.67s-223.67-100.14-223.67-223.67h-1.11c0 124.13 100.63 224.77 224.78 224.77 124.13 0 224.78-100.64 224.78-224.77 0-124.126-100.65-224.765-224.78-224.765-124.15 0-224.78 100.639-224.78 224.765"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F7903E",
                d: "M1558.31 1063.27c0-124.125 100.63-224.765 224.78-224.765 124.13 0 224.78 100.64 224.78 224.765 0 124.13-100.65 224.77-224.78 224.77-124.15 0-224.78-100.64-224.78-224.77h-1.1c0 124.75 101.13 225.88 225.88 225.88s225.88-101.13 225.88-225.88c0-124.74-101.13-225.87-225.88-225.87s-225.88 101.13-225.88 225.87"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F78F3D",
                d: "M1557.21 1063.27c0-124.741 101.13-225.87 225.88-225.87s225.88 101.129 225.88 225.87c0 124.75-101.13 225.88-225.88 225.88s-225.88-101.13-225.88-225.88h-1.11c0 125.36 101.63 226.99 226.99 226.99s226.99-101.63 226.99-226.99c0-125.356-101.63-226.975-226.99-226.975S1556.1 937.914 1556.1 1063.27"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F78F3D",
                d: "M1556.1 1063.27c0-125.355 101.62-226.975 226.99-226.975 125.36 0 226.99 101.62 226.99 226.975 0 125.36-101.63 226.99-226.99 226.99-125.37 0-226.99-101.63-226.99-226.99h-1.11c0 125.98 102.12 228.1 228.1 228.1 125.97 0 228.1-102.12 228.1-228.1 0-125.96-102.13-228.079-228.1-228.079-125.98 0-228.1 102.119-228.1 228.079"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F78E3B",
                d: "M1554.99 1063.27c0-125.96 102.12-228.079 228.1-228.079 125.97 0 228.1 102.119 228.1 228.079 0 125.98-102.13 228.1-228.1 228.1-125.98 0-228.1-102.12-228.1-228.1h-1.11c0 126.58 102.63 229.2 229.21 229.2s229.21-102.62 229.21-229.2c0-126.575-102.63-229.194-229.21-229.194s-229.21 102.619-229.21 229.194"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F78E3B",
                d: "M1553.88 1063.27c0-126.575 102.63-229.195 229.21-229.195s229.21 102.62 229.21 229.195c0 126.58-102.63 229.2-229.21 229.2s-229.21-102.62-229.21-229.2h-1.1c0 127.2 103.11 230.31 230.31 230.31s230.31-103.11 230.31-230.31c0-127.19-103.11-230.299-230.31-230.299s-230.31 103.109-230.31 230.299"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68D3A",
                d: "M1552.78 1063.27c0-127.189 103.11-230.299 230.31-230.299s230.31 103.11 230.31 230.299c0 127.2-103.11 230.31-230.31 230.31s-230.31-103.11-230.31-230.31h-1.11c0 127.8 103.62 231.42 231.42 231.42s231.42-103.62 231.42-231.42c0-127.794-103.62-231.404-231.42-231.404s-231.42 103.61-231.42 231.404"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F78D39",
                d: "M1551.67 1063.27c0-127.794 103.62-231.404 231.42-231.404s231.42 103.61 231.42 231.404c0 127.8-103.62 231.42-231.42 231.42s-231.42-103.62-231.42-231.42h-1.11c0 128.42 104.11 232.53 232.53 232.53s232.53-104.11 232.53-232.53c0-128.409-104.11-232.509-232.53-232.509s-232.53 104.1-232.53 232.509"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68C38",
                d: "M1550.56 1063.27c0-128.409 104.11-232.508 232.53-232.508s232.53 104.099 232.53 232.508c0 128.42-104.11 232.53-232.53 232.53s-232.53-104.11-232.53-232.53h-1.11c0 129.03 104.61 233.63 233.64 233.63s233.64-104.6 233.64-233.63c0-129.024-104.61-233.623-233.64-233.623s-233.64 104.599-233.64 233.623"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68B38",
                d: "M1549.45 1063.27c0-129.024 104.61-233.623 233.64-233.623s233.63 104.599 233.63 233.623c0 129.03-104.6 233.63-233.63 233.63s-233.64-104.6-233.64-233.63h-1.1c0 129.64 105.09 234.74 234.74 234.74 129.64 0 234.74-105.1 234.74-234.74 0-129.628-105.1-234.728-234.74-234.728-129.65 0-234.74 105.1-234.74 234.728"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68B37",
                d: "M1548.35 1063.27c0-129.628 105.09-234.728 234.74-234.728 129.64 0 234.74 105.1 234.74 234.728 0 129.64-105.1 234.74-234.74 234.74-129.65 0-234.74-105.1-234.74-234.74h-1.11c0 130.25 105.6 235.85 235.85 235.85s235.85-105.6 235.85-235.85c0-130.243-105.6-235.833-235.85-235.833s-235.85 105.59-235.85 235.833"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68A36",
                d: "M1547.24 1063.27c0-130.243 105.6-235.833 235.85-235.833s235.85 105.59 235.85 235.833c0 130.25-105.6 235.85-235.85 235.85s-235.85-105.6-235.85-235.85h-1.11c0 130.87 106.09 236.96 236.96 236.96 130.86 0 236.96-106.09 236.96-236.96 0-130.858-106.1-236.937-236.96-236.937-130.87 0-236.96 106.079-236.96 236.937"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68935",
                d: "M1546.13 1063.27c0-130.858 106.09-236.937 236.96-236.937 130.86 0 236.96 106.079 236.96 236.937 0 130.87-106.1 236.96-236.96 236.96-130.87 0-236.96-106.09-236.96-236.96h-1.11c0 131.48 106.59 238.06 238.07 238.06 131.47 0 238.06-106.58 238.06-238.06 0-131.473-106.59-238.052-238.06-238.052-131.48 0-238.07 106.579-238.07 238.052"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68934",
                d: "M1545.02 1063.27c0-131.473 106.59-238.052 238.07-238.052 131.47 0 238.06 106.579 238.06 238.052 0 131.48-106.59 238.06-238.06 238.06-131.48 0-238.07-106.58-238.07-238.06h-1.1c0 132.09 107.08 239.17 239.17 239.17s239.17-107.08 239.17-239.17c0-132.077-107.08-239.157-239.17-239.157s-239.17 107.08-239.17 239.157"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68934",
                d: "M1543.92 1063.27c0-132.077 107.08-239.157 239.17-239.157s239.17 107.08 239.17 239.157c0 132.08-107.08 239.16-239.17 239.16s-239.17-107.08-239.17-239.16h-1.11c0 132.7 107.58 240.28 240.28 240.28s240.27-107.58 240.27-240.28c0-132.692-107.57-240.262-240.27-240.262s-240.28 107.57-240.28 240.262"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68833",
                d: "M1542.81 1063.27c0-132.692 107.58-240.262 240.28-240.262s240.27 107.57 240.27 240.262c0 132.7-107.57 240.28-240.27 240.28s-240.28-107.58-240.28-240.28h-1.11c0 133.3 108.07 241.38 241.39 241.38 133.3 0 241.39-108.08 241.39-241.38 0-133.296-108.09-241.367-241.39-241.367-133.32 0-241.39 108.071-241.39 241.367"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68832",
                d: "M1541.7 1063.27c0-133.296 108.07-241.366 241.39-241.366 133.31 0 241.39 108.07 241.39 241.366 0 133.3-108.08 241.39-241.39 241.39-133.32 0-241.39-108.09-241.39-241.39h-1.1c0 133.92 108.56 242.49 242.49 242.49 133.92 0 242.49-108.57 242.49-242.49 0-133.911-108.57-242.481-242.49-242.481-133.93 0-242.49 108.57-242.49 242.481"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68731",
                d: "M1540.59 1063.27c0-133.911 108.57-242.482 242.5-242.482 133.92 0 242.49 108.571 242.49 242.482 0 133.92-108.57 242.49-242.49 242.49-133.93 0-242.5-108.57-242.5-242.49h-1.1c0 134.53 109.06 243.59 243.6 243.59 134.53 0 243.6-109.06 243.6-243.59 0-134.526-109.07-243.586-243.6-243.586-134.54 0-243.6 109.06-243.6 243.586"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68630",
                d: "M1539.49 1063.27c0-134.526 109.06-243.586 243.6-243.586 134.53 0 243.6 109.06 243.6 243.586 0 134.53-109.07 243.59-243.6 243.59-134.54 0-243.6-109.06-243.6-243.59h-1.11c0 135.15 109.56 244.71 244.71 244.71 135.14 0 244.7-109.56 244.7-244.71 0-135.141-109.56-244.691-244.7-244.691-135.15 0-244.71 109.55-244.71 244.691"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F6862F",
                d: "M1538.39 1063.27c0-135.141 109.55-244.691 244.7-244.691 135.14 0 244.7 109.55 244.7 244.691 0 135.15-109.56 244.71-244.7 244.71-135.15 0-244.7-109.56-244.7-244.71h-1.12c0 135.75 110.06 245.81 245.82 245.81 135.75 0 245.82-110.06 245.82-245.81 0-135.746-110.07-245.796-245.82-245.796-135.76 0-245.82 110.05-245.82 245.796"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F6852F",
                d: "M1537.27 1063.27c0-135.746 110.06-245.796 245.82-245.796 135.75 0 245.82 110.05 245.82 245.796 0 135.75-110.07 245.81-245.82 245.81-135.76 0-245.82-110.06-245.82-245.81h-1.1c0 136.37 110.55 246.92 246.92 246.92s246.92-110.55 246.92-246.92c0-136.361-110.55-246.911-246.92-246.911s-246.92 110.55-246.92 246.911"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F6852E",
                d: "M1536.17 1063.27c0-136.36 110.55-246.911 246.92-246.911s246.92 110.551 246.92 246.911c0 136.37-110.55 246.92-246.92 246.92s-246.92-110.55-246.92-246.92h-1.11c0 136.98 111.04 248.02 248.03 248.02 136.98 0 248.03-111.04 248.03-248.02 0-136.975-111.05-248.016-248.03-248.016-136.99 0-248.03 111.041-248.03 248.016"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F6842D",
                d: "M1535.06 1063.27c0-136.975 111.05-248.016 248.03-248.016s248.03 111.041 248.03 248.016c0 136.98-111.05 248.02-248.03 248.02s-248.03-111.04-248.03-248.02h-1.1c0 137.59 111.53 249.14 249.13 249.14 137.59 0 249.13-111.55 249.13-249.14 0-137.58-111.54-249.12-249.13-249.12-137.6 0-249.13 111.54-249.13 249.12"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F6842D",
                d: "M1533.96 1063.27c0-137.58 111.53-249.12 249.13-249.12 137.59 0 249.13 111.54 249.13 249.12 0 137.59-111.54 249.14-249.13 249.14-137.6 0-249.13-111.55-249.13-249.14h-1.12c0 138.2 112.05 250.24 250.25 250.24s250.25-112.04 250.25-250.24c0-138.195-112.05-250.225-250.25-250.225s-250.25 112.03-250.25 250.225"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F6832B",
                d: "M1532.84 1063.27c0-138.195 112.05-250.225 250.25-250.225s250.25 112.03 250.25 250.225c0 138.2-112.05 250.24-250.25 250.24s-250.25-112.04-250.25-250.24h-1.1c0 138.82 112.53 251.35 251.35 251.35 138.81 0 251.35-112.53 251.35-251.35 0-138.799-112.54-251.34-251.35-251.34-138.82 0-251.35 112.541-251.35 251.34"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F6822B",
                d: "M1531.74 1063.27c0-138.799 112.53-251.34 251.35-251.34 138.81 0 251.35 112.541 251.35 251.34 0 138.82-112.54 251.35-251.35 251.35-138.82 0-251.35-112.53-251.35-251.35h-1.11c0 139.42 113.04 252.45 252.46 252.45s252.46-113.03 252.46-252.45c0-139.414-113.04-252.444-252.46-252.444s-252.46 113.03-252.46 252.444"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F6822A",
                d: "M1530.63 1063.27c0-139.414 113.04-252.445 252.46-252.445s252.46 113.031 252.46 252.445c0 139.42-113.04 252.45-252.46 252.45s-252.46-113.03-252.46-252.45h-1.1c0 140.04 113.52 253.57 253.56 253.57s253.56-113.53 253.56-253.57c0-140.029-113.52-253.549-253.56-253.549s-253.56 113.52-253.56 253.549"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F68129",
                d: "M1529.53 1063.27c0-140.028 113.52-253.549 253.56-253.549s253.56 113.521 253.56 253.549c0 140.04-113.52 253.57-253.56 253.57s-253.56-113.53-253.56-253.57h-1.12c0 140.65 114.03 254.67 254.68 254.67s254.68-114.02 254.68-254.67c0-140.643-114.03-254.654-254.68-254.654s-254.68 114.011-254.68 254.654"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F58029",
                d: "M1528.41 1063.27c0-140.644 114.03-254.654 254.68-254.654s254.68 114.01 254.68 254.654c0 140.65-114.03 254.67-254.68 254.67s-254.68-114.02-254.68-254.67h-1.1c0 141.26 114.52 255.78 255.78 255.78s255.78-114.52 255.78-255.78c0-141.248-114.52-255.769-255.78-255.769s-255.78 114.521-255.78 255.769"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F58128",
                d: "M1527.31 1063.27c0-141.248 114.52-255.769 255.78-255.769s255.78 114.521 255.78 255.769c0 141.26-114.52 255.78-255.78 255.78s-255.78-114.52-255.78-255.78h-1.11c0 141.87 115.02 256.88 256.89 256.88s256.89-115.01 256.89-256.88c0-141.863-115.02-256.873-256.89-256.873s-256.89 115.01-256.89 256.873"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F58027",
                d: "M1526.2 1063.27c0-141.863 115.02-256.874 256.89-256.874s256.89 115.011 256.89 256.874c0 141.87-115.02 256.88-256.89 256.88s-256.89-115.01-256.89-256.88h-1.1c0 142.49 115.5 258 257.99 258s257.99-115.51 257.99-258c0-142.478-115.5-257.978-257.99-257.978s-257.99 115.5-257.99 257.978"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F57F26",
                d: "M1525.1 1063.27c0-142.478 115.5-257.978 257.99-257.978s257.99 115.5 257.99 257.978c0 142.49-115.5 258-257.99 258s-257.99-115.51-257.99-258h-1.12c0 143.1 116.01 259.1 259.11 259.1 143.09 0 259.11-116 259.11-259.1 0-143.082-116.02-259.083-259.11-259.083-143.1 0-259.11 116.001-259.11 259.083"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F57E26",
                d: "M1523.98 1063.27c0-143.082 116.01-259.083 259.11-259.083 143.09 0 259.11 116.001 259.11 259.083 0 143.1-116.02 259.1-259.11 259.1-143.1 0-259.11-116-259.11-259.1h-1.1c0 143.7 116.5 260.21 260.21 260.21s260.21-116.51 260.21-260.21c0-143.697-116.5-260.198-260.21-260.198s-260.21 116.501-260.21 260.198"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F57E25",
                d: "M1522.88 1063.27c0-143.697 116.5-260.198 260.21-260.198s260.21 116.501 260.21 260.198c0 143.71-116.5 260.21-260.21 260.21s-260.21-116.5-260.21-260.21h-1.11c0 144.32 117 261.31 261.32 261.31 144.31 0 261.32-116.99 261.32-261.31 0-144.312-117.01-261.303-261.32-261.303-144.32 0-261.32 116.991-261.32 261.303"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F57D24",
                d: "M1521.77 1063.27c0-144.312 117-261.303 261.32-261.303 144.31 0 261.32 116.991 261.32 261.303 0 144.32-117.01 261.31-261.32 261.31-144.32 0-261.32-116.99-261.32-261.31h-1.1c0 144.92 117.49 262.43 262.42 262.43s262.42-117.51 262.42-262.43c0-144.916-117.49-262.407-262.42-262.407s-262.42 117.491-262.42 262.407"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F57D23",
                d: "M1520.67 1063.27c0-144.917 117.49-262.408 262.42-262.408s262.42 117.491 262.42 262.408c0 144.92-117.49 262.43-262.42 262.43s-262.42-117.51-262.42-262.43h-1.12c0 145.54 118 263.52 263.54 263.52s263.54-117.98 263.54-263.52c0-145.532-118-263.513-263.54-263.513s-263.54 117.981-263.54 263.513"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F57D22",
                d: "M1519.55 1063.27c0-145.531 118-263.512 263.54-263.512s263.54 117.981 263.54 263.512c0 145.54-118 263.52-263.54 263.52s-263.54-117.98-263.54-263.52h-1.1c0 146.15 118.48 264.64 264.64 264.64 146.15 0 264.64-118.49 264.64-264.64 0-146.146-118.49-264.627-264.64-264.627-146.16 0-264.64 118.481-264.64 264.627"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F57C22",
                d: "M1518.45 1063.27c0-146.146 118.48-264.627 264.64-264.627s264.64 118.481 264.64 264.627c0 146.15-118.48 264.63-264.64 264.63s-264.64-118.48-264.64-264.63h-1.11c0 146.76 118.98 265.74 265.75 265.74 146.76 0 265.75-118.98 265.75-265.74 0-146.751-118.99-265.732-265.75-265.732-146.77 0-265.75 118.981-265.75 265.732"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F57B21",
                d: "M1517.34 1063.27c0-146.751 118.98-265.732 265.75-265.732 146.76 0 265.75 118.981 265.75 265.732 0 146.76-118.99 265.74-265.75 265.74-146.77 0-265.75-118.98-265.75-265.74h-1.1c0 147.37 119.47 266.84 266.85 266.84 147.37 0 266.85-119.47 266.85-266.84 0-147.366-119.48-266.837-266.85-266.837-147.38 0-266.85 119.471-266.85 266.837"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F57A21",
                d: "M1516.24 1063.27c0-147.365 119.47-266.837 266.85-266.837 147.37 0 266.85 119.472 266.85 266.837 0 147.37-119.48 266.84-266.85 266.84-147.38 0-266.85-119.47-266.85-266.84h-1.12c0 147.99 119.98 267.95 267.97 267.95 147.98 0 267.96-119.96 267.96-267.95 0-147.98-119.98-267.941-267.96-267.941-147.99 0-267.97 119.961-267.97 267.941"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F57A1F",
                d: "M1515.12 1063.27c0-147.98 119.98-267.941 267.97-267.941 147.98 0 267.97 119.961 267.97 267.941 0 147.99-119.99 267.95-267.97 267.95-147.99 0-267.97-119.96-267.97-267.95h-1.1c0 148.6 120.47 269.06 269.07 269.06 148.59 0 269.07-120.46 269.07-269.06 0-148.595-120.48-269.056-269.07-269.056-148.6 0-269.07 120.461-269.07 269.056"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F5791F",
                d: "M1514.02 1063.27c0-148.595 120.46-269.056 269.07-269.056 148.59 0 269.07 120.461 269.07 269.056 0 148.6-120.48 269.06-269.07 269.06-148.61 0-269.07-120.46-269.07-269.06h-1.11c0 149.21 120.97 270.17 270.18 270.17s270.17-120.96 270.17-270.17c0-149.2-120.96-270.161-270.17-270.161s-270.18 120.961-270.18 270.161"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F5791E",
                d: "M1512.91 1063.27c0-149.2 120.97-270.161 270.18-270.161s270.17 120.961 270.17 270.161c0 149.21-120.96 270.17-270.17 270.17s-270.18-120.96-270.18-270.17h-1.1c0 149.82 121.45 271.27 271.28 271.27 149.82 0 271.28-121.45 271.28-271.27 0-149.815-121.46-271.266-271.28-271.266-149.83 0-271.28 121.451-271.28 271.266"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F5791E",
                d: "M1511.81 1063.27c0-149.814 121.46-271.266 271.28-271.266s271.28 121.452 271.28 271.266c0 149.82-121.46 271.27-271.28 271.27s-271.28-121.45-271.28-271.27h-1.12c0 150.43 121.96 272.38 272.4 272.38 150.43 0 272.39-121.95 272.39-272.38 0-150.419-121.96-272.37-272.39-272.37-150.44 0-272.4 121.951-272.4 272.37"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F5781D",
                d: "M1510.69 1063.27c0-150.419 121.96-272.371 272.4-272.371 150.43 0 272.39 121.952 272.39 272.371 0 150.43-121.96 272.38-272.39 272.38-150.44 0-272.4-121.95-272.4-272.38h-1.1c0 151.04 122.45 273.49 273.5 273.49 151.04 0 273.5-122.45 273.5-273.49 0-151.034-122.46-273.486-273.5-273.486-151.05 0-273.5 122.452-273.5 273.486"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F5771C",
                d: "M1509.59 1063.27c0-151.034 122.45-273.485 273.5-273.485 151.04 0 273.5 122.451 273.5 273.485 0 151.04-122.46 273.49-273.5 273.49-151.05 0-273.5-122.45-273.5-273.49h-1.11c0 151.66 122.95 274.6 274.61 274.6s274.6-122.94 274.6-274.6c0-151.649-122.94-274.59-274.6-274.59s-274.61 122.941-274.61 274.59"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F5761B",
                d: "M1508.49 1063.27c0-151.649 122.94-274.59 274.6-274.59s274.6 122.941 274.6 274.59c0 151.66-122.94 274.6-274.6 274.6s-274.6-122.94-274.6-274.6h-1.11c0 152.27 123.44 275.7 275.71 275.7 152.26 0 275.71-123.43 275.71-275.7 0-152.264-123.45-275.695-275.71-275.695-152.27 0-275.71 123.431-275.71 275.695"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F5761B",
                d: "M1507.38 1063.27c0-152.264 123.44-275.695 275.71-275.695 152.26 0 275.71 123.431 275.71 275.695 0 152.27-123.45 275.7-275.71 275.7-152.27 0-275.71-123.43-275.71-275.7h-1.11c0 152.88 123.94 276.81 276.82 276.81s276.81-123.93 276.81-276.81c0-152.868-123.93-276.799-276.81-276.799s-276.82 123.931-276.82 276.799"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F5761A",
                d: "M1506.27 1063.27c0-152.868 123.94-276.799 276.82-276.799s276.81 123.931 276.81 276.799c0 152.88-123.93 276.81-276.81 276.81s-276.82-123.93-276.82-276.81h-1.1c0 153.49 124.43 277.92 277.92 277.92s277.92-124.43 277.92-277.92c0-153.483-124.43-277.914-277.92-277.914s-277.92 124.431-277.92 277.914"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F4751A",
                d: "M1505.17 1063.27c0-153.483 124.43-277.914 277.92-277.914s277.92 124.431 277.92 277.914c0 153.49-124.43 277.92-277.92 277.92s-277.92-124.43-277.92-277.92h-1.11c0 154.11 124.92 279.03 279.03 279.03s279.03-124.92 279.03-279.03c0-154.098-124.92-279.019-279.03-279.019s-279.03 124.921-279.03 279.019"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F47418",
                d: "M1504.06 1063.27c0-154.098 124.92-279.019 279.03-279.019s279.03 124.921 279.03 279.019c0 154.11-124.92 279.03-279.03 279.03s-279.03-124.92-279.03-279.03h-1.11c0 154.71 125.43 280.13 280.14 280.13s280.14-125.42 280.14-280.13c0-154.702-125.43-280.124-280.14-280.124s-280.14 125.422-280.14 280.124"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F47418",
                d: "M1502.95 1063.27c0-154.702 125.43-280.124 280.14-280.124s280.14 125.422 280.14 280.124c0 154.71-125.43 280.13-280.14 280.13s-280.14-125.42-280.14-280.13h-1.1c0 155.32 125.91 281.24 281.24 281.24s281.24-125.92 281.24-281.24c0-155.317-125.91-281.229-281.24-281.229s-281.24 125.912-281.24 281.229"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F47317",
                d: "M1501.85 1063.27c0-155.317 125.91-281.228 281.24-281.228s281.24 125.911 281.24 281.228c0 155.32-125.91 281.24-281.24 281.24s-281.24-125.92-281.24-281.24h-1.11c0 155.94 126.41 282.35 282.35 282.35 155.93 0 282.35-126.41 282.35-282.35 0-155.921-126.42-282.343-282.35-282.343-155.94 0-282.35 126.422-282.35 282.343"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F47217",
                d: "M1500.74 1063.27c0-155.921 126.41-282.343 282.35-282.343 155.93 0 282.35 126.422 282.35 282.343 0 155.94-126.42 282.35-282.35 282.35-155.94 0-282.35-126.41-282.35-282.35h-1.11c0 156.54 126.91 283.46 283.46 283.46s283.46-126.92 283.46-283.46c0-156.536-126.91-283.448-283.46-283.448s-283.46 126.912-283.46 283.448"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "#F47217",
                d: "M1499.63 1063.27c0 156.54 126.91 283.46 283.46 283.46s283.46-126.92 283.46-283.46c0-156.536-126.91-283.448-283.46-283.448s-283.46 126.912-283.46 283.448m570.11 283.46h-573.31V779.822h573.31z"
              }
            )
          ] }),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#151922",
              d: "M276.411 1197.09c-33.103 29.91-75.722 42.84-143.454 42.84h-28.145V884.256h28.145c67.732 0 108.723 12.11 143.454 43.524 36.235 32.258 57.835 82.21 57.835 133.79 0 51.68-21.6 103.39-57.835 135.52M153.972 793.199H0v537.761h153.163c81.266 0 140.04-19.28 191.591-62.05 61.169-50.8 97.452-127.4 97.452-206.57 0-158.769-118.447-269.141-288.234-269.141M491.001 1330.96h104.707V793.199H491.001zM852.911 999.459c-62.867-23.351-81.369-38.752-81.369-67.698 0-33.916 32.94-59.716 78.095-59.716 31.392 0 57.15 12.9 84.602 43.472l54.665-71.699c-45.071-39.627-98.998-59.768-157.822-59.768-94.894 0-167.396 66.197-167.396 154.067 0 74.303 33.782 112.193 132.023 147.783 41.08 14.45 61.963 24.09 72.451 30.68 20.925 13.72 31.434 33.01 31.434 55.6 0 43.64-34.646 75.86-81.401 75.86-49.911 0-90.118-24.98-114.289-71.78l-67.533 65.44c48.198 70.91 106.167 102.48 185.949 102.48 108.665 0 185.1-72.72 185.1-176.78 0-85.55-35.334-124.31-154.509-167.941M1039.95 1062.34c0 158.26 124.63 280.82 284.87 280.82 45.3 0 84.13-8.92 131.92-31.42v-123.47c-42.13 41.98-79.36 58.87-127.11 58.87-105.97 0-181.26-76.64-181.26-185.57 0-103.192 77.64-184.669 176.45-184.669 50.09 0 88.18 17.737 131.92 60.481v-123.46C1410.63 790.603 1372.53 781 1327.23 781c-159.43 0-287.28 125.043-287.28 281.34M2307.18 1154.76l-143.96-361.561h-114.84l228.94 551.991h56.57l232.94-551.991h-114zM2613.59 1330.96h298.87v-91.03h-193.57v-145.26h186.17v-91.06h-186.17V884.256h193.57v-91.057h-298.87zM3117.26 1040.71h-30.57V877.759h32.25c65.57 0 101.09 27.499 101.09 79.832 0 53.989-35.52 83.119-102.77 83.119m210.83-88.804c0-100.741-69.37-158.707-190.59-158.707h-155.91v537.761h105.1v-216.13h13.76l145.31 216.13H3375l-169.73-226.52c79.28-16.18 122.82-70.23 122.82-152.534"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#231F20",
              d: "M3332.73 106.997h-1.95V95.583h2.05c5.17 0 7.79 1.881 7.79 5.615 0 3.85-2.73 5.799-7.89 5.799m18.32-5.973c0-8.731-5.83-13.468-16.52-13.468h-14.15v43.889h10.4v-17.067l12.28 17.067h13.03l-14.59-18.138c6.15-1.631 9.55-6.166 9.55-12.283"
            }
          )
        ]
      }
    )
  }
));
i.displayName = "DiscoverIcon";
export {
  i as DiscoverIcon,
  i as default
};
//# sourceMappingURL=index.js.map
